// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/sylvanus/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        newAgentExecutionApiV1AgentExecutionPost: build.mutation<NewAgentExecutionApiV1AgentExecutionPostApiResponse, NewAgentExecutionApiV1AgentExecutionPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/agent-execution`,
                method: "POST",
                body: queryArg.newAgentExecutionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getExecutionApiV1AgentExecutionAgentExecutionIdGet: build.query<GetExecutionApiV1AgentExecutionAgentExecutionIdGetApiResponse, GetExecutionApiV1AgentExecutionAgentExecutionIdGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/agent-execution/${queryArg.agentExecutionId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteAgentExecutionApiV1AgentExecutionAeIdDelete: build.mutation<DeleteAgentExecutionApiV1AgentExecutionAeIdDeleteApiResponse, DeleteAgentExecutionApiV1AgentExecutionAeIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/agent-execution/${queryArg.aeId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listAgentExecutionsApiV1AgentExecutionsGet: build.query<ListAgentExecutionsApiV1AgentExecutionsGetApiResponse, ListAgentExecutionsApiV1AgentExecutionsGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/agent-executions`,
                params: {
                    entity_type: queryArg.entityType,
                    execution_tag: queryArg.executionTag,
                    page: queryArg.page,
                    size: queryArg.size,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createAgentExecutionMessageApiV1AgentExecutionAeIdMessagePost: build.mutation<CreateAgentExecutionMessageApiV1AgentExecutionAeIdMessagePostApiResponse, CreateAgentExecutionMessageApiV1AgentExecutionAeIdMessagePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/agent-execution/${queryArg.aeId}/message`,
                method: "POST",
                body: queryArg.agentExecutionMessageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        interruptAgentExecutionApiV1AgentExecutionAeIdInterruptPost: build.mutation<InterruptAgentExecutionApiV1AgentExecutionAeIdInterruptPostApiResponse, InterruptAgentExecutionApiV1AgentExecutionAeIdInterruptPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/agent-execution/${queryArg.aeId}/interrupt`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getAiMessageStreamApiV1AgentExecutionAeIdAiMessageStreamPost: build.mutation<GetAiMessageStreamApiV1AgentExecutionAeIdAiMessageStreamPostApiResponse, GetAiMessageStreamApiV1AgentExecutionAeIdAiMessageStreamPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/agent-execution/${queryArg.aeId}/ai-message/stream`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getBackgroundAgentStreamApiV1AgentExecutionAeIdAiMessageStreamGet: build.query<GetBackgroundAgentStreamApiV1AgentExecutionAeIdAiMessageStreamGetApiResponse, GetBackgroundAgentStreamApiV1AgentExecutionAeIdAiMessageStreamGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/agent-execution/${queryArg.aeId}/ai-message/stream`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateAeMessageApiV1AgentExecutionAeIdMessageMessageIdPatch: build.mutation<UpdateAeMessageApiV1AgentExecutionAeIdMessageMessageIdPatchApiResponse, UpdateAeMessageApiV1AgentExecutionAeIdMessageMessageIdPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/agent-execution/${queryArg.aeId}/message/${queryArg.messageId}`,
                method: "PATCH",
                body: queryArg.updateAgentExecutionMessageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        newConversationApiV1ConversationPost: build.mutation<NewConversationApiV1ConversationPostApiResponse, NewConversationApiV1ConversationPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/conversation`,
                method: "POST",
                body: queryArg.newConversationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getConversationApiV1ConversationConversationIdGet: build.query<GetConversationApiV1ConversationConversationIdGetApiResponse, GetConversationApiV1ConversationConversationIdGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/conversation/${queryArg.conversationId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteConversationApiV1ConversationConversationIdDelete: build.mutation<DeleteConversationApiV1ConversationConversationIdDeleteApiResponse, DeleteConversationApiV1ConversationConversationIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/conversation/${queryArg.conversationId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateConversationApiV1ConversationConversationIdPatch: build.mutation<UpdateConversationApiV1ConversationConversationIdPatchApiResponse, UpdateConversationApiV1ConversationConversationIdPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/conversation/${queryArg.conversationId}`,
                method: "PATCH",
                body: queryArg.updateConversationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listConversationsApiV1ConversationsGet: build.query<ListConversationsApiV1ConversationsGetApiResponse, ListConversationsApiV1ConversationsGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/conversations`,
                params: {
                    entity_type: queryArg.entityType,
                    entity_id: queryArg.entityId,
                    cursor: queryArg.cursor,
                    page_size: queryArg.pageSize,
                    page: queryArg.page,
                    size: queryArg.size,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createMessageApiV1ConversationConversationIdMessagePost: build.mutation<CreateMessageApiV1ConversationConversationIdMessagePostApiResponse, CreateMessageApiV1ConversationConversationIdMessagePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/conversation/${queryArg.conversationId}/message`,
                method: "POST",
                body: queryArg.sendConversationMessageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        interruptConversationApiV1ConversationConversationIdInterruptPost: build.mutation<InterruptConversationApiV1ConversationConversationIdInterruptPostApiResponse, InterruptConversationApiV1ConversationConversationIdInterruptPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/conversation/${queryArg.conversationId}/interrupt`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getAiMessageApiV1ConversationConversationIdAiMessagePost: build.mutation<GetAiMessageApiV1ConversationConversationIdAiMessagePostApiResponse, GetAiMessageApiV1ConversationConversationIdAiMessagePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/conversation/${queryArg.conversationId}/ai-message`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getAiMessageStreamApiV1ConversationConversationIdAiMessageStreamPost: build.mutation<GetAiMessageStreamApiV1ConversationConversationIdAiMessageStreamPostApiResponse, GetAiMessageStreamApiV1ConversationConversationIdAiMessageStreamPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/conversation/${queryArg.conversationId}/ai-message/stream`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateMessageApiV1ConversationConversationIdMessageMessageIdPatch: build.mutation<UpdateMessageApiV1ConversationConversationIdMessageMessageIdPatchApiResponse, UpdateMessageApiV1ConversationConversationIdMessageMessageIdPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/conversation/${queryArg.conversationId}/message/${queryArg.messageId}`,
                method: "PATCH",
                body: queryArg.updateConversationMessageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        acceptDisclaimerApiV1UserAcceptDisclaimerPost: build.mutation<AcceptDisclaimerApiV1UserAcceptDisclaimerPostApiResponse, AcceptDisclaimerApiV1UserAcceptDisclaimerPostApiArg>({
            query: () => ({ url: `/api/v1/user/accept-disclaimer`, method: "POST" }),
        }),
        declineDisclaimerApiV1UserDeclineDisclaimerPost: build.mutation<DeclineDisclaimerApiV1UserDeclineDisclaimerPostApiResponse, DeclineDisclaimerApiV1UserDeclineDisclaimerPostApiArg>({
            query: () => ({ url: `/api/v1/user/decline-disclaimer`, method: "POST" }),
        }),
        newConversationWdInternalApiV1WdInternalConversationPost: build.mutation<NewConversationWdInternalApiV1WdInternalConversationPostApiResponse, NewConversationWdInternalApiV1WdInternalConversationPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wd-internal/conversation`,
                method: "POST",
                body: queryArg.newConversationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getConversationApiV1WdInternalConversationConversationIdGet: build.query<GetConversationApiV1WdInternalConversationConversationIdGetApiResponse, GetConversationApiV1WdInternalConversationConversationIdGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wd-internal/conversation/${queryArg.conversationId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteConversationApiV1WdInternalConversationConversationIdDelete: build.mutation<DeleteConversationApiV1WdInternalConversationConversationIdDeleteApiResponse, DeleteConversationApiV1WdInternalConversationConversationIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wd-internal/conversation/${queryArg.conversationId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateConversationApiV1WdInternalConversationConversationIdPatch: build.mutation<UpdateConversationApiV1WdInternalConversationConversationIdPatchApiResponse, UpdateConversationApiV1WdInternalConversationConversationIdPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wd-internal/conversation/${queryArg.conversationId}`,
                method: "PATCH",
                body: queryArg.updateConversationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listConversationsApiV1WdInternalConversationsGet: build.query<ListConversationsApiV1WdInternalConversationsGetApiResponse, ListConversationsApiV1WdInternalConversationsGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wd-internal/conversations`,
                params: {
                    entity_type: queryArg.entityType,
                    entity_id: queryArg.entityId,
                    cursor: queryArg.cursor,
                    page_size: queryArg.pageSize,
                    page: queryArg.page,
                    size: queryArg.size,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createMessageInternalApiV1WdInternalConversationConversationIdMessagePost: build.mutation<CreateMessageInternalApiV1WdInternalConversationConversationIdMessagePostApiResponse, CreateMessageInternalApiV1WdInternalConversationConversationIdMessagePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wd-internal/conversation/${queryArg.conversationId}/message`,
                method: "POST",
                body: queryArg.sendConversationMessageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        interruptConversationApiV1WdInternalConversationConversationIdInterruptPost: build.mutation<InterruptConversationApiV1WdInternalConversationConversationIdInterruptPostApiResponse, InterruptConversationApiV1WdInternalConversationConversationIdInterruptPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wd-internal/conversation/${queryArg.conversationId}/interrupt`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getAiMessageInternalApiV1WdInternalConversationConversationIdAiMessagePost: build.mutation<GetAiMessageInternalApiV1WdInternalConversationConversationIdAiMessagePostApiResponse, GetAiMessageInternalApiV1WdInternalConversationConversationIdAiMessagePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wd-internal/conversation/${queryArg.conversationId}/ai-message`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getAiMessageStreamInternalApiV1WdInternalConversationConversationIdAiMessageStreamPost: build.mutation<GetAiMessageStreamInternalApiV1WdInternalConversationConversationIdAiMessageStreamPostApiResponse, GetAiMessageStreamInternalApiV1WdInternalConversationConversationIdAiMessageStreamPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wd-internal/conversation/${queryArg.conversationId}/ai-message/stream`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateMessageApiV1WdInternalConversationConversationIdMessageMessageIdPatch: build.mutation<UpdateMessageApiV1WdInternalConversationConversationIdMessageMessageIdPatchApiResponse, UpdateMessageApiV1WdInternalConversationConversationIdMessageMessageIdPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wd-internal/conversation/${queryArg.conversationId}/message/${queryArg.messageId}`,
                method: "PATCH",
                body: queryArg.updateConversationMessageRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        acceptDisclaimerApiV1WdInternalUserAcceptDisclaimerPost: build.mutation<AcceptDisclaimerApiV1WdInternalUserAcceptDisclaimerPostApiResponse, AcceptDisclaimerApiV1WdInternalUserAcceptDisclaimerPostApiArg>({
            query: () => ({
                url: `/api/v1/wd-internal/user/accept-disclaimer`,
                method: "POST",
            }),
        }),
        declineDisclaimerApiV1WdInternalUserDeclineDisclaimerPost: build.mutation<DeclineDisclaimerApiV1WdInternalUserDeclineDisclaimerPostApiResponse, DeclineDisclaimerApiV1WdInternalUserDeclineDisclaimerPostApiArg>({
            query: () => ({
                url: `/api/v1/wd-internal/user/decline-disclaimer`,
                method: "POST",
            }),
        }),
        listTargetedEntitiesApiV1ModelTargetedEntitiesGet: build.query<ListTargetedEntitiesApiV1ModelTargetedEntitiesGetApiResponse, ListTargetedEntitiesApiV1ModelTargetedEntitiesGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/targeted-entities`,
                params: {
                    entity_type: queryArg.entityType,
                    page: queryArg.page,
                    size: queryArg.size,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listTargetEntitiesApiV1ModelTargetEntitiesGet: build.query<ListTargetEntitiesApiV1ModelTargetEntitiesGetApiResponse, ListTargetEntitiesApiV1ModelTargetEntitiesGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/target-entities`,
                params: {
                    entity_type: queryArg.entityType,
                    cursor: queryArg.cursor,
                    page_size: queryArg.pageSize,
                    use_evisearch: queryArg.useEvisearch,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createModelApiV1ModelPost: build.mutation<CreateModelApiV1ModelPostApiResponse, CreateModelApiV1ModelPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model`,
                method: "POST",
                body: queryArg.promptModelCreate,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listModelsApiV1ModelGet: build.query<ListModelsApiV1ModelGetApiResponse, ListModelsApiV1ModelGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model`,
                params: {
                    include_latest_version: queryArg.includeLatestVersion,
                    include_published_version: queryArg.includePublishedVersion,
                    include_test_cases: queryArg.includeTestCases,
                    status: queryArg.status,
                    sort_by: queryArg.sortBy,
                    reverse: queryArg.reverse,
                    page: queryArg.page,
                    size: queryArg.size,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getModelApiV1ModelModelIdGet: build.query<GetModelApiV1ModelModelIdGetApiResponse, GetModelApiV1ModelModelIdGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}`,
                params: {
                    all_versions: queryArg.allVersions,
                    include_versions: queryArg.includeVersions,
                    include_test_cases: queryArg.includeTestCases,
                    include_latest_version: queryArg.includeLatestVersion,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteModelApiV1ModelModelIdDelete: build.mutation<DeleteModelApiV1ModelModelIdDeleteApiResponse, DeleteModelApiV1ModelModelIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getModelsForEntityApiV1ModelsEntityTypeEntityIdGet: build.query<GetModelsForEntityApiV1ModelsEntityTypeEntityIdGetApiResponse, GetModelsForEntityApiV1ModelsEntityTypeEntityIdGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/models/${queryArg.entityType}/${queryArg.entityId}`,
                params: {
                    sort_by: queryArg.sortBy,
                    reverse: queryArg.reverse,
                    page: queryArg.page,
                    size: queryArg.size,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getModelSummaryApiV1ModelsSummaryGet: build.query<GetModelSummaryApiV1ModelsSummaryGetApiResponse, GetModelSummaryApiV1ModelsSummaryGetApiArg>({
            query: () => ({ url: `/api/v1/models/summary` }),
        }),
        getModelProgressApiV1ModelModelIdProgressGet: build.query<GetModelProgressApiV1ModelModelIdProgressGetApiResponse, GetModelProgressApiV1ModelModelIdProgressGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/progress`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateModelProgressApiV1ModelModelIdProgressPatch: build.mutation<UpdateModelProgressApiV1ModelModelIdProgressPatchApiResponse, UpdateModelProgressApiV1ModelModelIdProgressPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/progress`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createModelVersionApiV1ModelModelIdVersionPost: build.mutation<CreateModelVersionApiV1ModelModelIdVersionPostApiResponse, CreateModelVersionApiV1ModelModelIdVersionPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/version`,
                method: "POST",
                body: queryArg.versionCreate,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getModelVersionApiV1ModelModelIdVersionVersionNumberGet: build.query<GetModelVersionApiV1ModelModelIdVersionVersionNumberGetApiResponse, GetModelVersionApiV1ModelModelIdVersionVersionNumberGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/version/${queryArg.versionNumber}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcasePost: build.mutation<CreateModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcasePostApiResponse, CreateModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcasePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/version/${queryArg.versionNumber}/testcase`,
                method: "POST",
                params: {
                    entity_type: queryArg.entityType,
                    entity_id: queryArg.entityId,
                    trigger_execution: queryArg.triggerExecution,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberGet: build.query<GetModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberGetApiResponse, GetModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/version/${queryArg.versionNumber}/testcase/${queryArg.testcaseNumber}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberPatch: build.mutation<UpdateTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberPatchApiResponse, UpdateTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/version/${queryArg.versionNumber}/testcase/${queryArg.testcaseNumber}`,
                method: "PATCH",
                body: queryArg.promptModelTestCaseFeedback,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        executeTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberExecutePost: build.mutation<ExecuteTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberExecutePostApiResponse, ExecuteTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberExecutePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/version/${queryArg.versionNumber}/testcase/${queryArg.testcaseNumber}/execute`,
                method: "POST",
                params: { force: queryArg.force },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        executeVersionTestcasesApiV1ModelModelIdVersionVersionNumberExecutePost: build.mutation<ExecuteVersionTestcasesApiV1ModelModelIdVersionVersionNumberExecutePostApiResponse, ExecuteVersionTestcasesApiV1ModelModelIdVersionVersionNumberExecutePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/version/${queryArg.versionNumber}/execute`,
                method: "POST",
                params: { force: queryArg.force },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getExecuteVersionTestcasesStreamApiV1ModelModelIdVersionVersionNumberExecuteGet: build.query<GetExecuteVersionTestcasesStreamApiV1ModelModelIdVersionVersionNumberExecuteGetApiResponse, GetExecuteVersionTestcasesStreamApiV1ModelModelIdVersionVersionNumberExecuteGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/version/${queryArg.versionNumber}/execute`,
                params: { stream_id: queryArg.streamId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        triggerOptimizeApiV1ModelModelIdVersionVersionNumberOptimizePost: build.mutation<TriggerOptimizeApiV1ModelModelIdVersionVersionNumberOptimizePostApiResponse, TriggerOptimizeApiV1ModelModelIdVersionVersionNumberOptimizePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/version/${queryArg.versionNumber}/optimize`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getOptimizeApiV1ModelModelIdVersionVersionNumberOptimizeGet: build.query<GetOptimizeApiV1ModelModelIdVersionVersionNumberOptimizeGetApiResponse, GetOptimizeApiV1ModelModelIdVersionVersionNumberOptimizeGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/version/${queryArg.versionNumber}/optimize`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getOptimizeSummaryApiV1ModelModelIdVersionVersionNumberOptimizeSummaryGet: build.query<GetOptimizeSummaryApiV1ModelModelIdVersionVersionNumberOptimizeSummaryGetApiResponse, GetOptimizeSummaryApiV1ModelModelIdVersionVersionNumberOptimizeSummaryGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/version/${queryArg.versionNumber}/optimize/summary`,
                params: { format: queryArg.format },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        modelConfigSuggestInitialApiV1ModelConfigSuggestPost: build.mutation<ModelConfigSuggestInitialApiV1ModelConfigSuggestPostApiResponse, ModelConfigSuggestInitialApiV1ModelConfigSuggestPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/config-suggest`,
                method: "POST",
                body: queryArg.request,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        modelConfigSuggestApiV1ModelModelIdConfigSuggestGet: build.query<ModelConfigSuggestApiV1ModelModelIdConfigSuggestGetApiResponse, ModelConfigSuggestApiV1ModelModelIdConfigSuggestGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/config-suggest`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        modelConfigCheckApiV1ModelConfigCheckPost: build.mutation<ModelConfigCheckApiV1ModelConfigCheckPostApiResponse, ModelConfigCheckApiV1ModelConfigCheckPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/config-check`,
                method: "POST",
                body: queryArg.promptModelConfigCreateInput,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        publishModelApiV1ModelModelIdPublishPost: build.mutation<PublishModelApiV1ModelModelIdPublishPostApiResponse, PublishModelApiV1ModelModelIdPublishPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/publish`,
                method: "POST",
                body: queryArg.promptModelPublish,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPublishWorkflowApiV1ModelModelIdPublishGet: build.query<GetPublishWorkflowApiV1ModelModelIdPublishGetApiResponse, GetPublishWorkflowApiV1ModelModelIdPublishGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/publish`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteWorkflowApiV1ModelModelIdPublishDelete: build.mutation<DeleteWorkflowApiV1ModelModelIdPublishDeleteApiResponse, DeleteWorkflowApiV1ModelModelIdPublishDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/publish`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createPredictionWorkflowExternalApiV1ModelModelIdPredictPost: build.mutation<CreatePredictionWorkflowExternalApiV1ModelModelIdPredictPostApiResponse, CreatePredictionWorkflowExternalApiV1ModelModelIdPredictPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/predict`,
                method: "POST",
                body: queryArg.promptModelWorkflowCreate,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getAllPredictionForModelLastPublishApiV1ModelModelIdPredictGet: build.query<GetAllPredictionForModelLastPublishApiV1ModelModelIdPredictGetApiResponse, GetAllPredictionForModelLastPublishApiV1ModelModelIdPredictGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/predict`,
                params: {
                    status: queryArg.status,
                    cursor: queryArg.cursor,
                    page_size: queryArg.pageSize,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdGet: build.query<GetPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdGetApiResponse, GetPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/predict/${queryArg.workflowId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        rerunPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdPatch: build.mutation<RerunPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdPatchApiResponse, RerunPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/predict/${queryArg.workflowId}`,
                method: "PATCH",
                params: { force: queryArg.force },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getPredictionForDocumentApiV1ModelModelIdPredictEntityTypeEntityIdGet: build.query<GetPredictionForDocumentApiV1ModelModelIdPredictEntityTypeEntityIdGetApiResponse, GetPredictionForDocumentApiV1ModelModelIdPredictEntityTypeEntityIdGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/predict/${queryArg.entityType}/${queryArg.entityId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        suspendPublishWorkflowApiV1ModelModelIdSuspendPatch: build.mutation<SuspendPublishWorkflowApiV1ModelModelIdSuspendPatchApiResponse, SuspendPublishWorkflowApiV1ModelModelIdSuspendPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/${queryArg.modelId}/suspend`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDocsInScopeApiV1ModelDocsInScopePost: build.mutation<GetDocsInScopeApiV1ModelDocsInScopePostApiResponse, GetDocsInScopeApiV1ModelDocsInScopePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/model/docs-in-scope`,
                method: "POST",
                body: queryArg.promptModelSearchScope,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        generateClauseApiV1ClauseGeneratePost: build.mutation<GenerateClauseApiV1ClauseGeneratePostApiResponse, GenerateClauseApiV1ClauseGeneratePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/clause/generate`,
                method: "POST",
                body: queryArg.clauseGenerationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        redlineClauseApiV1ClauseRedlinePost: build.mutation<RedlineClauseApiV1ClauseRedlinePostApiResponse, RedlineClauseApiV1ClauseRedlinePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/clause/redline`,
                method: "POST",
                body: queryArg.clauseRedliningRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listModelsInternalApiV1InternalModelGet: build.query<ListModelsInternalApiV1InternalModelGetApiResponse, ListModelsInternalApiV1InternalModelGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/model`,
                params: {
                    client_id: queryArg.clientId,
                    include_latest_version: queryArg.includeLatestVersion,
                    include_published_version: queryArg.includePublishedVersion,
                    include_test_cases: queryArg.includeTestCases,
                    status: queryArg.status,
                    sort_by: queryArg.sortBy,
                    reverse: queryArg.reverse,
                    page: queryArg.page,
                    size: queryArg.size,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getModelInternalViewApiV1InternalModelModelIdIdentityGet: build.query<GetModelInternalViewApiV1InternalModelModelIdIdentityGetApiResponse, GetModelInternalViewApiV1InternalModelModelIdIdentityGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/model/${queryArg.modelId}/identity`,
                params: {
                    client_id: queryArg.clientId,
                    model_version: queryArg.modelVersion,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateModelProgressInternalApiV1InternalModelModelIdProgressPatch: build.mutation<UpdateModelProgressInternalApiV1InternalModelModelIdProgressPatchApiResponse, UpdateModelProgressInternalApiV1InternalModelModelIdProgressPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/model/${queryArg.modelId}/progress`,
                method: "PATCH",
                params: { client_id: queryArg.clientId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        triggerInternalOptimizeApiV1InternalModelModelIdVersionVersionNumberOptimizePost: build.mutation<TriggerInternalOptimizeApiV1InternalModelModelIdVersionVersionNumberOptimizePostApiResponse, TriggerInternalOptimizeApiV1InternalModelModelIdVersionVersionNumberOptimizePostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/model/${queryArg.modelId}/version/${queryArg.versionNumber}/optimize`,
                method: "POST",
                params: {
                    client_id: queryArg.clientId,
                    user_id: queryArg.userId,
                    user_email: queryArg.userEmail,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createPredictionWorkflowInternalApiV1InternalModelModelIdPredictPost: build.mutation<CreatePredictionWorkflowInternalApiV1InternalModelModelIdPredictPostApiResponse, CreatePredictionWorkflowInternalApiV1InternalModelModelIdPredictPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/model/${queryArg.modelId}/predict`,
                method: "POST",
                body: queryArg.promptModelWorkflowCreate,
                params: {
                    client_id: queryArg.clientId,
                    user_id: queryArg.userId,
                    user_email: queryArg.userEmail,
                    reprocess_customai: queryArg.reprocessCustomai,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createGroupPredictionWorkflowInternalApiV1InternalModelModelIdGroupPredictPost: build.mutation<CreateGroupPredictionWorkflowInternalApiV1InternalModelModelIdGroupPredictPostApiResponse, CreateGroupPredictionWorkflowInternalApiV1InternalModelModelIdGroupPredictPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/model/${queryArg.modelId}/group-predict`,
                method: "POST",
                body: queryArg.groupExecuteWorkflowCreate,
                params: {
                    client_id: queryArg.clientId,
                    user_id: queryArg.userId,
                    user_email: queryArg.userEmail,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        checkDocInModelScopeApiV1InternalModelModelIdVersionVersionNumberCheckScopeGet: build.query<CheckDocInModelScopeApiV1InternalModelModelIdVersionVersionNumberCheckScopeGetApiResponse, CheckDocInModelScopeApiV1InternalModelModelIdVersionVersionNumberCheckScopeGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/internal/model/${queryArg.modelId}/version/${queryArg.versionNumber}/check-scope`,
                params: {
                    client_id: queryArg.clientId,
                    entity_id: queryArg.entityId,
                    entity_type: queryArg.entityType,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getModelSummaryForClientApiV1ModelsClientClientIdSummaryGet: build.query<GetModelSummaryForClientApiV1ModelsClientClientIdSummaryGetApiResponse, GetModelSummaryForClientApiV1ModelsClientClientIdSummaryGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/models/client/${queryArg.clientId}/summary`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getLibraryModelsApiV1LibraryModelGet: build.query<GetLibraryModelsApiV1LibraryModelGetApiResponse, GetLibraryModelsApiV1LibraryModelGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/library/model`,
                params: { page_size: queryArg.pageSize, cursor: queryArg.cursor },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createNewLibraryModelApiV1LibraryModelPost: build.mutation<CreateNewLibraryModelApiV1LibraryModelPostApiResponse, CreateNewLibraryModelApiV1LibraryModelPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/library/model`,
                method: "POST",
                body: queryArg.initialLibraryModelVersionCreate,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getLibraryModelPublishStatusApiV1LibraryModelPublishGet: build.query<GetLibraryModelPublishStatusApiV1LibraryModelPublishGetApiResponse, GetLibraryModelPublishStatusApiV1LibraryModelPublishGetApiArg>({
            query: () => ({ url: `/api/v1/library/model/publish` }),
        }),
        publishLibraryModelsApiV1LibraryModelPublishPost: build.mutation<PublishLibraryModelsApiV1LibraryModelPublishPostApiResponse, PublishLibraryModelsApiV1LibraryModelPublishPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/library/model/publish`,
                method: "POST",
                body: queryArg.libraryPublishRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getLibraryModelApiV1LibraryModelLibraryModelIdGet: build.query<GetLibraryModelApiV1LibraryModelLibraryModelIdGetApiResponse, GetLibraryModelApiV1LibraryModelLibraryModelIdGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/library/model/${queryArg.libraryModelId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteLibraryModelApiV1LibraryModelLibraryModelIdDelete: build.mutation<DeleteLibraryModelApiV1LibraryModelLibraryModelIdDeleteApiResponse, DeleteLibraryModelApiV1LibraryModelLibraryModelIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/library/model/${queryArg.libraryModelId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberGet: build.query<GetLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberGetApiResponse, GetLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/library/model/${queryArg.libraryModelId}/version/${queryArg.libraryModelVersionNumber}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberDelete: build.mutation<DeleteLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberDeleteApiResponse, DeleteLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/library/model/${queryArg.libraryModelId}/version/${queryArg.libraryModelVersionNumber}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createNewLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionPost: build.mutation<CreateNewLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionPostApiResponse, CreateNewLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/library/model/${queryArg.libraryModelId}/version`,
                method: "POST",
                body: queryArg.nextLibraryModelVersionCreate,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createExtractionTableApiV1DdeTablesPost: build.mutation<CreateExtractionTableApiV1DdeTablesPostApiResponse, CreateExtractionTableApiV1DdeTablesPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/tables`,
                method: "POST",
                body: queryArg.ddeExtractionTableCreate,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listExtractionTablesApiV1DdeTablesGet: build.query<ListExtractionTablesApiV1DdeTablesGetApiResponse, ListExtractionTablesApiV1DdeTablesGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/tables`,
                params: { page: queryArg.page, size: queryArg.size },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getExtractionTableApiV1DdeTableTableIdGet: build.query<GetExtractionTableApiV1DdeTableTableIdGetApiResponse, GetExtractionTableApiV1DdeTableTableIdGetApiArg>({
            query: (queryArg) => ({ url: `/api/v1/dde/table/${queryArg.tableId}`, rtkQueryOptions: (queryArg as any)?.rtkQueryOptions }),
        }),
        renameExtractionTableApiV1DdeTableTableIdPatch: build.mutation<RenameExtractionTableApiV1DdeTableTableIdPatchApiResponse, RenameExtractionTableApiV1DdeTableTableIdPatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/table/${queryArg.tableId}`,
                method: "PATCH",
                body: queryArg.ddeExtractionTableRename,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteExtractionTableApiV1DdeTableTableIdDelete: build.mutation<DeleteExtractionTableApiV1DdeTableTableIdDeleteApiResponse, DeleteExtractionTableApiV1DdeTableTableIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/table/${queryArg.tableId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getExtractionTableRowsApiV1DdeTableTableIdRowsGet: build.query<GetExtractionTableRowsApiV1DdeTableTableIdRowsGetApiResponse, GetExtractionTableRowsApiV1DdeTableTableIdRowsGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/table/${queryArg.tableId}/rows`,
                params: { page: queryArg.page, page_size: queryArg.pageSize },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        addDocumentsToExtractionTableApiV1DdeTableTableIdUploadPost: build.mutation<AddDocumentsToExtractionTableApiV1DdeTableTableIdUploadPostApiResponse, AddDocumentsToExtractionTableApiV1DdeTableTableIdUploadPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/table/${queryArg.tableId}/upload`,
                method: "POST",
                body: queryArg.searchScope,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        removeDocumentsFromExtractionTableApiV1DdeTableTableIdDocumentHandlerIdDelete: build.mutation<RemoveDocumentsFromExtractionTableApiV1DdeTableTableIdDocumentHandlerIdDeleteApiResponse, RemoveDocumentsFromExtractionTableApiV1DdeTableTableIdDocumentHandlerIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/table/${queryArg.tableId}/${queryArg.documentHandlerId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createDdeModelInitialVersionApiV1DdeTableTableIdModelPost: build.mutation<CreateDdeModelInitialVersionApiV1DdeTableTableIdModelPostApiResponse, CreateDdeModelInitialVersionApiV1DdeTableTableIdModelPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/table/${queryArg.tableId}/model`,
                method: "POST",
                body: queryArg.ddeModelCreate,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listDdeModelsApiV1DdeTableTableIdModelsGet: build.query<ListDdeModelsApiV1DdeTableTableIdModelsGetApiResponse, ListDdeModelsApiV1DdeTableTableIdModelsGetApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/table/${queryArg.tableId}/models`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteDdeModelApiV1DdeTableTableIdModelModelIdDelete: build.mutation<DeleteDdeModelApiV1DdeTableTableIdModelModelIdDeleteApiResponse, DeleteDdeModelApiV1DdeTableTableIdModelModelIdDeleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/table/${queryArg.tableId}/model/${queryArg.modelId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createDdeModelVersionApiV1DdeTableTableIdModelModelIdVersionPost: build.mutation<CreateDdeModelVersionApiV1DdeTableTableIdModelModelIdVersionPostApiResponse, CreateDdeModelVersionApiV1DdeTableTableIdModelModelIdVersionPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/table/${queryArg.tableId}/model/${queryArg.modelId}/version`,
                method: "POST",
                body: queryArg.ddeModelVersionCreate,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        runExtractionApiV1DdeTableTableIdExtractPost: build.mutation<RunExtractionApiV1DdeTableTableIdExtractPostApiResponse, RunExtractionApiV1DdeTableTableIdExtractPostApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/dde/table/${queryArg.tableId}/extract`,
                method: "POST",
                params: { model_id: queryArg.modelId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        fieldAiPocApiV1FieldAiPocGet: build.query<FieldAiPocApiV1FieldAiPocGetApiResponse, FieldAiPocApiV1FieldAiPocGetApiArg>({
            query: () => ({ url: `/api/v1/field_ai_poc` }),
        }),
        fieldAiClassificationPocApiV1FieldAiClassificationPocGet: build.query<FieldAiClassificationPocApiV1FieldAiClassificationPocGetApiResponse, FieldAiClassificationPocApiV1FieldAiClassificationPocGetApiArg>({
            query: () => ({ url: `/api/v1/field_ai_classification_poc` }),
        }),
        tableExtractionPocApiV1TableExtractionPocGet: build.query<TableExtractionPocApiV1TableExtractionPocGetApiResponse, TableExtractionPocApiV1TableExtractionPocGetApiArg>({
            query: () => ({ url: `/api/v1/table_extraction_poc` }),
        }),
        healthcheckHealthGet: build.query<HealthcheckHealthGetApiResponse, HealthcheckHealthGetApiArg>({
            query: () => ({ url: `/health` }),
        }),
        healthcheckHealthShallowGet: build.query<HealthcheckHealthShallowGetApiResponse, HealthcheckHealthShallowGetApiArg>({
            query: () => ({ url: `/health/shallow` }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type NewAgentExecutionApiV1AgentExecutionPostApiResponse = 
/** status 201 Create a new Agent Execution.

The endpoint accepts an agent_type enum and agent_configuration object along with an option execution_tag.
- agent_type: defines the type of agent that will run under this execution, e.g. ask_ai, ai_playbook, etc...
- agent_configuration: defines the starting configuration for the agent. It will contains references to objects that the
  agent requires in order to initialize and it depends on the type of agent being executed.
  For example: ask_ai may have information about starting scope and type of ask conversation. Whereas ai_playbook will
  have references to the playbook being run and the targeted ticket.
- execution_tag: an optional string that can also be provided to the list agent executions for grouping executions.

Creating the agent execution will initialize the agent by running the agent specific prepare method as an async
background task. This method will form a message stream that the ai-stream endpoint will listen on before processing
a user message. This stream is used to pass status messages from the prepare method to a waiting user via the thinking
events. When the prepare method completes, it will close the prepare stream, and the agent will be initialized and it
can start handling any user inputs expected by that agent.

Creating an agent-execution creates an internal conversation object that must be referenced by uuid. All interactions
with the agent execution must use the uuid returned from the create agent-execution endpoint.

*/ AgentExecution;
export type NewAgentExecutionApiV1AgentExecutionPostApiArg = {
    newAgentExecutionRequest: NewAgentExecutionRequest;
};
export type GetExecutionApiV1AgentExecutionAgentExecutionIdGetApiResponse = 
/** status 200 Successful Response */ AgentExecution;
export type GetExecutionApiV1AgentExecutionAgentExecutionIdGetApiArg = {
    agentExecutionId: string;
};
export type DeleteAgentExecutionApiV1AgentExecutionAeIdDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteAgentExecutionApiV1AgentExecutionAeIdDeleteApiArg = {
    aeId: string;
};
export type ListAgentExecutionsApiV1AgentExecutionsGetApiResponse = 
/** status 200 Lists the agent executions started by the requesting user.

The endpoint will return a list of agent-executions that the requesting user started.
This endpoint accepts an optional parameter, execution_tag, which will return only the executions created with
the respective tag.

*/ PageAgentExecution;
export type ListAgentExecutionsApiV1AgentExecutionsGetApiArg = {
    entityType?: ExternalEntityType | null;
    executionTag?: string | null;
    /** Page number */
    page?: number;
    /** Page size */
    size?: number;
};
export type CreateAgentExecutionMessageApiV1AgentExecutionAeIdMessagePostApiResponse = 
/** status 201 Sends user input the the agent execution in the form of the AgentExecutionMessage.

This message will be added to the underlying conversation for the agent, and will be processed with the next ai-stream
call.

*/ AgentExecutionMessage;
export type CreateAgentExecutionMessageApiV1AgentExecutionAeIdMessagePostApiArg = {
    aeId: string;
    agentExecutionMessageRequest: AgentExecutionMessageRequest;
};
export type InterruptAgentExecutionApiV1AgentExecutionAeIdInterruptPostApiResponse = 
/** status 202 Successful Response */ any;
export type InterruptAgentExecutionApiV1AgentExecutionAeIdInterruptPostApiArg = {
    aeId: string;
};
export type GetAiMessageStreamApiV1AgentExecutionAeIdAiMessageStreamPostApiResponse = 
/** status 201 Request that the AI continue the agent execution with the last submitted user
message, and stream the response as AgentExecutionStreamEvent objects.

This endpoint streams the response messages from the bot using SSE (Server Sent Events).

The message return type is not actually application/json, but text/event-stream. Each event data will be json
of the specified `AgentExecutionStreamEvent` schema.

The supported event types is expanding with newly supported agents.

| `event_type`                  | Description                                                                                                                                  | Recommended FE action                                                                                                                                                                                                              | has `text`  | has `message` |
|-------------------------------|----------------------------------------------------------------------------------------------------------------------------------------------|------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|-------------|---------------|
| `thinking`                    | Sylvanus is processing.<br>May include a user-friendly description of what is being processed.                                               | display loading icon<br>optionally display `text` promptmodel to user                                                                                                                                                                    | optional    | no            |
| `message_start`               | A new message will be generated.<br>Expect a stream of `delta` events, potentially interspersed with<br>`message_response_suggestion_events` | prepare for new message, e.g.:<br>- initialize empty message data<br>- create empty message box                                                                                                                                    | no          | no            |
| `message_delta`               | A fragment of the current message.<br>Not guaraunteed to be any particular length.                                                           | - add the text to the current message data<br>- reformat the message data as html and display to the user                                                                                                                          | yes         | no            |
| `message_response_suggestion` | Represents a suggestion to the user for their next response.<br>Extracted from the current message text.                                     | - search for the `text` from this message in the current message data<br>- replace that text with a button allowing the user to use that suggestion                                                                                | yes         | no            |
| `message_end`                 | The message is finished. Also contains message metadata like `id`, <br>`datetime_created` , `allowable_user_actions` etc.                    | - add the message metadata to the message object<br>- finalize display of the message to the user<br>- allow the user to perform the `allowable_user_actions`<br>- prepare for (potentially) another message in the current stream | no          | yes           |
| `stream_end`                  | This stream of messages has finished                                                                                                         | - close the stream object<br>- allow the user to send messages again                                                                                                                                                               | no          | no            |
*/ AgentExecutionStreamEvent;
export type GetAiMessageStreamApiV1AgentExecutionAeIdAiMessageStreamPostApiArg = {
    aeId: string;
};
export type GetBackgroundAgentStreamApiV1AgentExecutionAeIdAiMessageStreamGetApiResponse = 
/** status 200 Request that the AI continue the agent execution with the last submitted user
message, and stream the response as AgentExecutionStreamEvent objects.

This endpoint streams the response messages from the bot using SSE (Server Sent Events).

The message return type is not actually application/json, but text/event-stream. Each event data will be json
of the specified `AgentExecutionStreamEvent` schema.

The supported event types is expanding with newly supported agents.

| `event_type`                  | Description                                                                                                                                  | Recommended FE action                                                                                                                                                                                                              | has `text`  | has `message` |
|-------------------------------|----------------------------------------------------------------------------------------------------------------------------------------------|------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|-------------|---------------|
| `thinking`                    | Sylvanus is processing.<br>May include a user-friendly description of what is being processed.                                               | display loading icon<br>optionally display `text` promptmodel to user                                                                                                                                                                    | optional    | no            |
| `message_start`               | A new message will be generated.<br>Expect a stream of `delta` events, potentially interspersed with<br>`message_response_suggestion_events` | prepare for new message, e.g.:<br>- initialize empty message data<br>- create empty message box                                                                                                                                    | no          | no            |
| `message_delta`               | A fragment of the current message.<br>Not guaraunteed to be any particular length.                                                           | - add the text to the current message data<br>- reformat the message data as html and display to the user                                                                                                                          | yes         | no            |
| `message_response_suggestion` | Represents a suggestion to the user for their next response.<br>Extracted from the current message text.                                     | - search for the `text` from this message in the current message data<br>- replace that text with a button allowing the user to use that suggestion                                                                                | yes         | no            |
| `message_end`                 | The message is finished. Also contains message metadata like `id`, <br>`datetime_created` , `allowable_user_actions` etc.                    | - add the message metadata to the message object<br>- finalize display of the message to the user<br>- allow the user to perform the `allowable_user_actions`<br>- prepare for (potentially) another message in the current stream | no          | yes           |
| `stream_end`                  | This stream of messages has finished                                                                                                         | - close the stream object<br>- allow the user to send messages again                                                                                                                                                               | no          | no            |
*/ AgentExecutionStreamEvent;
export type GetBackgroundAgentStreamApiV1AgentExecutionAeIdAiMessageStreamGetApiArg = {
    aeId: string;
};
export type UpdateAeMessageApiV1AgentExecutionAeIdMessageMessageIdPatchApiResponse = 
/** status 200 Successful Response */ AgentExecutionMessage;
export type UpdateAeMessageApiV1AgentExecutionAeIdMessageMessageIdPatchApiArg = {
    aeId: string;
    messageId: number;
    updateAgentExecutionMessageRequest: UpdateAgentExecutionMessageRequest;
};
export type NewConversationApiV1ConversationPostApiResponse = 
/** status 201 Create a new conversation.

This endpoint will accept the given document_id/document_link (document link must be to a valid EvisortDocument avro
file. It will then:

1. Load the doc from the link / pilot
2. Analyze the doc by generating embeddings.
3. Save the embeddings.
4. Create a new Conversation object in the database.
5. Return the new conversation object.

The new conversation object will not have any messages. After creating the conversation, get the initial series of
messages by calling POST /api/v1/conversation/{conversation_id}/message or
POST /api/v1/conversation/{conversation_id}/message/stream with an body of {"message": null}.

That call will then return the initial messages from the bot.
*/ Conversation;
export type NewConversationApiV1ConversationPostApiArg = {
    newConversationRequest: NewConversationRequest;
};
export type GetConversationApiV1ConversationConversationIdGetApiResponse = 
/** status 200 Successful Response */ Conversation;
export type GetConversationApiV1ConversationConversationIdGetApiArg = {
    conversationId: string;
};
export type DeleteConversationApiV1ConversationConversationIdDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteConversationApiV1ConversationConversationIdDeleteApiArg = {
    conversationId: string;
};
export type UpdateConversationApiV1ConversationConversationIdPatchApiResponse = 
/** status 200 Successful Response */ Conversation;
export type UpdateConversationApiV1ConversationConversationIdPatchApiArg = {
    conversationId: string;
    updateConversationRequest: UpdateConversationRequest;
};
export type ListConversationsApiV1ConversationsGetApiResponse = 
/** status 200 List Conversations that a user has access to.

Note that this returns Conversation objects, which do not include the messages. To get the messages, use
`GET /api/v1/conversation/{conversation_id}/message` on each conversation id.

## Legacy mode (default, no `cursor`)

By default this lists conversations with fastapi-pagination (`page`/`size`) and returns
`{items, total, page, size, pages}`. This path is used by per-surface resume-latest and wd-internal
callers and is unchanged for existing GA traffic.

This can be filtered by entity_type/entity_id to get the most recent conversation for a given entity. E.g.:
`GET /api/v1/conversations?entity_type=document_handler&entity_id=1234&size=1` will return the most recent
conversation for the document handler with id 1234.

Note that requesting a conversation for the latest `document_version` of a `document_handler` is equivalent to
requesting the latest conversation for the `document_handler` - internally conversations are indexed by the
`document_version`'s id.

## Conversation History cursor mode (opt-in)

Pass `cursor` (empty string for the first page) and optional `page_size` (default 20, max 100) to opt into
unified Conversation History pagination. Response shape is `{items, cursor}` (`DynamoDbPage`). Results are
bounded to a configurable activity window (default 90 days) and served from the activity GSI.
Do not combine `cursor` with `entity_type`/`entity_id`.
*/ any;
export type ListConversationsApiV1ConversationsGetApiArg = {
    entityType?: ExternalEntityType | null;
    entityId?: string | null;
    cursor?: string | null;
    pageSize?: number | null;
    page?: number;
    size?: number;
};
export type CreateMessageApiV1ConversationConversationIdMessagePostApiResponse = 
/** status 201 Send a message to a conversation.

This endpoint will accept a message from the user and add it to the conversation, returning the created message.
*/ ConversationMessage;
export type CreateMessageApiV1ConversationConversationIdMessagePostApiArg = {
    conversationId: string;
    sendConversationMessageRequest: SendConversationMessageRequest;
};
export type InterruptConversationApiV1ConversationConversationIdInterruptPostApiResponse = 
/** status 202 Successful Response */ any;
export type InterruptConversationApiV1ConversationConversationIdInterruptPostApiArg = {
    conversationId: string;
};
export type GetAiMessageApiV1ConversationConversationIdAiMessagePostApiResponse = 
/** status 201 Request that the AI continue the conversation.

This will cause sylvanus to generate a new AI message relevant to the current conversation. The generated messages
will be returned in the response.
*/ AiMessageResponse;
export type GetAiMessageApiV1ConversationConversationIdAiMessagePostApiArg = {
    conversationId: string;
};
export type GetAiMessageStreamApiV1ConversationConversationIdAiMessageStreamPostApiResponse = 
/** status 201 Request that the AI continue the conversation, but stream the response messages as
they are generated.

This endpoint will accept a message from the user and stream the response messages from the bot using SSE (Server Sent
Events).

The message return type is not actually application/json, but text/event-stream. Each event data will be json
of the specified `ConversationStreamEvent` schema.

| `event_type`                  | Description                                                                                                                                  | Recommended FE action                                                                                                                                                                                                              | has `text`  | has `message` |
|-------------------------------|----------------------------------------------------------------------------------------------------------------------------------------------|------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|-------------|---------------|
| `thinking`                    | Sylvanus is processing.<br>May include a user-friendly description of what is being processed.                                               | display loading icon<br>optionally display `text` promptmodel to user                                                                                                                                                                    | optional    | no            |
| `message_start`               | A new message will be generated.<br>Expect a stream of `delta` events, potentially interspersed with<br>`message_response_suggestion_events` | prepare for new message, e.g.:<br>- initialize empty message data<br>- create empty message box                                                                                                                                    | no          | no            |
| `message_delta`               | A fragment of the current message.<br>Not guaraunteed to be any particular length.                                                           | - add the text to the current message data<br>- reformat the message data as html and display to the user                                                                                                                          | yes         | no            |
| `message_response_suggestion` | Represents a suggestion to the user for their next response.<br>Extracted from the current message text.                                     | - search for the `text` from this message in the current message data<br>- replace that text with a button allowing the user to use that suggestion                                                                                | yes         | no            |
| `message_end`                 | The message is finished. Also contains message metadata like `id`, <br>`datetime_created` , `allowable_user_actions` etc.                    | - add the message metadata to the message object<br>- finalize display of the message to the user<br>- allow the user to perform the `allowable_user_actions`<br>- prepare for (potentially) another message in the current stream | no          | yes           |
| `stream_end`                  | This stream of messages has finished                                                                                                         | - close the stream object<br>- allow the user to send messages again                                                                                                                                                               | no          | no            |
*/ ConversationStreamEvent;
export type GetAiMessageStreamApiV1ConversationConversationIdAiMessageStreamPostApiArg = {
    conversationId: string;
};
export type UpdateMessageApiV1ConversationConversationIdMessageMessageIdPatchApiResponse = 
/** status 200 Successful Response */ ConversationMessage;
export type UpdateMessageApiV1ConversationConversationIdMessageMessageIdPatchApiArg = {
    conversationId: string;
    messageId: number;
    updateConversationMessageRequest: UpdateConversationMessageRequest;
};
export type AcceptDisclaimerApiV1UserAcceptDisclaimerPostApiResponse = 
/** status 200 Successful Response */ User;
export type AcceptDisclaimerApiV1UserAcceptDisclaimerPostApiArg = void;
export type DeclineDisclaimerApiV1UserDeclineDisclaimerPostApiResponse = 
/** status 200 Successful Response */ User | null;
export type DeclineDisclaimerApiV1UserDeclineDisclaimerPostApiArg = void;
export type NewConversationWdInternalApiV1WdInternalConversationPostApiResponse = 
/** status 201 Create a new conversation.

This endpoint will accept the given document_id/document_link (document link must be to a valid EvisortDocument avro
file. It will then:

1. Load the doc from the link / pilot
2. Analyze the doc by generating embeddings.
3. Save the embeddings.
4. Create a new Conversation object in the database.
5. Return the new conversation object.

The new conversation object will not have any messages. After creating the conversation, get the initial series of
messages by calling POST /api/v1/conversation/{conversation_id}/message or
POST /api/v1/conversation/{conversation_id}/message/stream with an body of {"message": null}.

That call will then return the initial messages from the bot.
*/ Conversation;
export type NewConversationWdInternalApiV1WdInternalConversationPostApiArg = {
    newConversationRequest: NewConversationRequest;
};
export type GetConversationApiV1WdInternalConversationConversationIdGetApiResponse = 
/** status 200 Successful Response */ Conversation;
export type GetConversationApiV1WdInternalConversationConversationIdGetApiArg = {
    conversationId: string;
};
export type DeleteConversationApiV1WdInternalConversationConversationIdDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteConversationApiV1WdInternalConversationConversationIdDeleteApiArg = {
    conversationId: string;
};
export type UpdateConversationApiV1WdInternalConversationConversationIdPatchApiResponse = 
/** status 200 Successful Response */ Conversation;
export type UpdateConversationApiV1WdInternalConversationConversationIdPatchApiArg = {
    conversationId: string;
    updateConversationRequest: UpdateConversationRequest;
};
export type ListConversationsApiV1WdInternalConversationsGetApiResponse = 
/** status 200 List Conversations that a user has access to.

Note that this returns Conversation objects, which do not include the messages. To get the messages, use
`GET /api/v1/conversation/{conversation_id}/message` on each conversation id.

## Legacy mode (default, no `cursor`)

By default this lists conversations with fastapi-pagination (`page`/`size`) and returns
`{items, total, page, size, pages}`. This path is used by per-surface resume-latest and wd-internal
callers and is unchanged for existing GA traffic.

This can be filtered by entity_type/entity_id to get the most recent conversation for a given entity. E.g.:
`GET /api/v1/conversations?entity_type=document_handler&entity_id=1234&size=1` will return the most recent
conversation for the document handler with id 1234.

Note that requesting a conversation for the latest `document_version` of a `document_handler` is equivalent to
requesting the latest conversation for the `document_handler` - internally conversations are indexed by the
`document_version`'s id.

## Conversation History cursor mode (opt-in)

Pass `cursor` (empty string for the first page) and optional `page_size` (default 20, max 100) to opt into
unified Conversation History pagination. Response shape is `{items, cursor}` (`DynamoDbPage`). Results are
bounded to a configurable activity window (default 90 days) and served from the activity GSI.
Do not combine `cursor` with `entity_type`/`entity_id`.
*/ any;
export type ListConversationsApiV1WdInternalConversationsGetApiArg = {
    entityType?: ExternalEntityType | null;
    entityId?: string | null;
    cursor?: string | null;
    pageSize?: number | null;
    page?: number;
    size?: number;
};
export type CreateMessageInternalApiV1WdInternalConversationConversationIdMessagePostApiResponse = 
/** status 201 Send a message to a conversation.

This endpoint will accept a message from the user and add it to the conversation, returning the created message.
*/ ConversationMessage;
export type CreateMessageInternalApiV1WdInternalConversationConversationIdMessagePostApiArg = {
    conversationId: string;
    sendConversationMessageRequest: SendConversationMessageRequest;
};
export type InterruptConversationApiV1WdInternalConversationConversationIdInterruptPostApiResponse = 
/** status 202 Successful Response */ any;
export type InterruptConversationApiV1WdInternalConversationConversationIdInterruptPostApiArg = {
    conversationId: string;
};
export type GetAiMessageInternalApiV1WdInternalConversationConversationIdAiMessagePostApiResponse = 
/** status 201 Request that the AI continue the conversation.

This will cause sylvanus to generate a new AI message relevant to the current conversation. The generated messages
will be returned in the response.
*/ AiMessageResponse;
export type GetAiMessageInternalApiV1WdInternalConversationConversationIdAiMessagePostApiArg = {
    conversationId: string;
};
export type GetAiMessageStreamInternalApiV1WdInternalConversationConversationIdAiMessageStreamPostApiResponse = 
/** status 201 Request that the AI continue the conversation, but stream the response messages as
they are generated.

This endpoint will accept a message from the user and stream the response messages from the bot using SSE (Server Sent
Events).

The message return type is not actually application/json, but text/event-stream. Each event data will be json
of the specified `ConversationStreamEvent` schema.

| `event_type`                  | Description                                                                                                                                  | Recommended FE action                                                                                                                                                                                                              | has `text`  | has `message` |
|-------------------------------|----------------------------------------------------------------------------------------------------------------------------------------------|------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|-------------|---------------|
| `thinking`                    | Sylvanus is processing.<br>May include a user-friendly description of what is being processed.                                               | display loading icon<br>optionally display `text` promptmodel to user                                                                                                                                                                    | optional    | no            |
| `message_start`               | A new message will be generated.<br>Expect a stream of `delta` events, potentially interspersed with<br>`message_response_suggestion_events` | prepare for new message, e.g.:<br>- initialize empty message data<br>- create empty message box                                                                                                                                    | no          | no            |
| `message_delta`               | A fragment of the current message.<br>Not guaraunteed to be any particular length.                                                           | - add the text to the current message data<br>- reformat the message data as html and display to the user                                                                                                                          | yes         | no            |
| `message_response_suggestion` | Represents a suggestion to the user for their next response.<br>Extracted from the current message text.                                     | - search for the `text` from this message in the current message data<br>- replace that text with a button allowing the user to use that suggestion                                                                                | yes         | no            |
| `message_end`                 | The message is finished. Also contains message metadata like `id`, <br>`datetime_created` , `allowable_user_actions` etc.                    | - add the message metadata to the message object<br>- finalize display of the message to the user<br>- allow the user to perform the `allowable_user_actions`<br>- prepare for (potentially) another message in the current stream | no          | yes           |
| `stream_end`                  | This stream of messages has finished                                                                                                         | - close the stream object<br>- allow the user to send messages again                                                                                                                                                               | no          | no            |
*/ ConversationStreamEvent;
export type GetAiMessageStreamInternalApiV1WdInternalConversationConversationIdAiMessageStreamPostApiArg = {
    conversationId: string;
};
export type UpdateMessageApiV1WdInternalConversationConversationIdMessageMessageIdPatchApiResponse = 
/** status 200 Successful Response */ ConversationMessage;
export type UpdateMessageApiV1WdInternalConversationConversationIdMessageMessageIdPatchApiArg = {
    conversationId: string;
    messageId: number;
    updateConversationMessageRequest: UpdateConversationMessageRequest;
};
export type AcceptDisclaimerApiV1WdInternalUserAcceptDisclaimerPostApiResponse = 
/** status 200 Successful Response */ User;
export type AcceptDisclaimerApiV1WdInternalUserAcceptDisclaimerPostApiArg = void;
export type DeclineDisclaimerApiV1WdInternalUserDeclineDisclaimerPostApiResponse = 
/** status 200 Successful Response */ User | null;
export type DeclineDisclaimerApiV1WdInternalUserDeclineDisclaimerPostApiArg = void;
export type ListTargetedEntitiesApiV1ModelTargetedEntitiesGetApiResponse = 
/** status 200 Successful Response */ PageTargetEntityResponseItem;
export type ListTargetedEntitiesApiV1ModelTargetedEntitiesGetApiArg = {
    entityType?: "field" | null;
    /** Page number */
    page?: number;
    /** Page size */
    size?: number;
};
export type ListTargetEntitiesApiV1ModelTargetEntitiesGetApiResponse = 
/** status 200 Successful Response */ DynamoDbPageTargetEntityResponseItem;
export type ListTargetEntitiesApiV1ModelTargetEntitiesGetApiArg = {
    entityType?: "field" | null;
    cursor?: string | null;
    pageSize?: number | null;
    useEvisearch?: boolean;
};
export type CreateModelApiV1ModelPostApiResponse = 
/** status 201 Successful Response */ PromptModel;
export type CreateModelApiV1ModelPostApiArg = {
    promptModelCreate: PromptModelCreate;
};
export type ListModelsApiV1ModelGetApiResponse = 
/** status 200 Successful Response */ PagePromptModel;
export type ListModelsApiV1ModelGetApiArg = {
    includeLatestVersion?: boolean;
    includePublishedVersion?: boolean;
    includeTestCases?: boolean;
    status?: PromptModelStatus | null;
    sortBy?: PromptModelSortByField | null;
    reverse?: boolean | null;
    /** Page number */
    page?: number;
    /** Page size */
    size?: number;
};
export type GetModelApiV1ModelModelIdGetApiResponse = 
/** status 200 Successful Response */ PromptModel;
export type GetModelApiV1ModelModelIdGetApiArg = {
    modelId: string;
    allVersions?: boolean;
    includeVersions?: number[];
    includeTestCases?: boolean;
    includeLatestVersion?: boolean;
};
export type DeleteModelApiV1ModelModelIdDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteModelApiV1ModelModelIdDeleteApiArg = {
    modelId: string;
};
export type GetModelsForEntityApiV1ModelsEntityTypeEntityIdGetApiResponse = 
/** status 200 Successful Response */ PagePromptModel;
export type GetModelsForEntityApiV1ModelsEntityTypeEntityIdGetApiArg = {
    entityType: ExternalEntityType;
    entityId: string;
    sortBy?: PromptModelSortByField | null;
    reverse?: boolean | null;
    /** Page number */
    page?: number;
    /** Page size */
    size?: number;
};
export type GetModelSummaryApiV1ModelsSummaryGetApiResponse = 
/** status 200 Successful Response */ PromptModelSummary;
export type GetModelSummaryApiV1ModelsSummaryGetApiArg = void;
export type GetModelProgressApiV1ModelModelIdProgressGetApiResponse = 
/** status 200 Successful Response */ PromptModelProgress;
export type GetModelProgressApiV1ModelModelIdProgressGetApiArg = {
    modelId: string;
};
export type UpdateModelProgressApiV1ModelModelIdProgressPatchApiResponse = 
/** status 204 Successful Response */ void;
export type UpdateModelProgressApiV1ModelModelIdProgressPatchApiArg = {
    modelId: string;
};
export type CreateModelVersionApiV1ModelModelIdVersionPostApiResponse = 
/** status 201 Successful Response */ PromptModelVersion;
export type CreateModelVersionApiV1ModelModelIdVersionPostApiArg = {
    modelId: string;
    versionCreate: PromptModelVersionCreateFromConfig | PromptModelVersionCreateFromLibrary;
};
export type GetModelVersionApiV1ModelModelIdVersionVersionNumberGetApiResponse = 
/** status 200 Successful Response */ PromptModelVersion;
export type GetModelVersionApiV1ModelModelIdVersionVersionNumberGetApiArg = {
    modelId: string;
    versionNumber: number;
};
export type CreateModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcasePostApiResponse = 
/** status 201 Successful Response */ PromptModelTestCase;
export type CreateModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcasePostApiArg = {
    modelId: string;
    versionNumber: number;
    entityType?: ("document_version" | "document_handler") | null;
    entityId?: string | null;
    triggerExecution?: boolean;
};
export type GetModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberGetApiResponse = 
/** status 200 Successful Response */ PromptModelTestCase;
export type GetModelTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberGetApiArg = {
    modelId: string;
    versionNumber: number;
    testcaseNumber: number;
};
export type UpdateTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberPatchApiResponse = 
/** status 200 Successful Response */ PromptModelTestCase;
export type UpdateTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberPatchApiArg = {
    modelId: string;
    versionNumber: number;
    testcaseNumber: number;
    promptModelTestCaseFeedback: PromptModelTestCaseFeedback;
};
export type ExecuteTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberExecutePostApiResponse = 
/** status 200 Successful Response */ PromptModelTestCase;
export type ExecuteTestcaseApiV1ModelModelIdVersionVersionNumberTestcaseTestcaseNumberExecutePostApiArg = {
    modelId: string;
    versionNumber: number;
    testcaseNumber: number;
    /** If true, forces re-execution of already complete testcases. */
    force?: boolean;
};
export type ExecuteVersionTestcasesApiV1ModelModelIdVersionVersionNumberExecutePostApiResponse = 
/** status 202 Successful Response */ PromptModelTestCaseExecuteResponse;
export type ExecuteVersionTestcasesApiV1ModelModelIdVersionVersionNumberExecutePostApiArg = {
    modelId: string;
    versionNumber: number;
    force?: boolean;
};
export type GetExecuteVersionTestcasesStreamApiV1ModelModelIdVersionVersionNumberExecuteGetApiResponse = 
/** status 200 Successful Response */ PromptModelTestCase;
export type GetExecuteVersionTestcasesStreamApiV1ModelModelIdVersionVersionNumberExecuteGetApiArg = {
    modelId: string;
    versionNumber: number;
    streamId?: string | null;
};
export type TriggerOptimizeApiV1ModelModelIdVersionVersionNumberOptimizePostApiResponse = 
/** status 202 Successful Response */ any;
export type TriggerOptimizeApiV1ModelModelIdVersionVersionNumberOptimizePostApiArg = {
    modelId: string;
    versionNumber: number;
};
export type GetOptimizeApiV1ModelModelIdVersionVersionNumberOptimizeGetApiResponse = 
/** status 200 Successful Response */ OptimizeRun;
export type GetOptimizeApiV1ModelModelIdVersionVersionNumberOptimizeGetApiArg = {
    modelId: string;
    versionNumber: number;
};
export type GetOptimizeSummaryApiV1ModelModelIdVersionVersionNumberOptimizeSummaryGetApiResponse = 
/** status 200 Successful Response */ any;
export type GetOptimizeSummaryApiV1ModelModelIdVersionVersionNumberOptimizeSummaryGetApiArg = {
    modelId: string;
    versionNumber: number;
    format?: "json" | "md";
};
export type ModelConfigSuggestInitialApiV1ModelConfigSuggestPostApiResponse = 
/** status 200 Successful Response */ PromptModelConfigSuggestResponse;
export type ModelConfigSuggestInitialApiV1ModelConfigSuggestPostApiArg = {
    request: PromptModelConfigCreate | FieldConfigSuggestRequest;
};
export type ModelConfigSuggestApiV1ModelModelIdConfigSuggestGetApiResponse = 
/** status 200 Successful Response */ PromptModelConfigSuggestResponse;
export type ModelConfigSuggestApiV1ModelModelIdConfigSuggestGetApiArg = {
    modelId: string;
};
export type ModelConfigCheckApiV1ModelConfigCheckPostApiResponse = 
/** status 204 Successful Response */ void;
export type ModelConfigCheckApiV1ModelConfigCheckPostApiArg = {
    promptModelConfigCreateInput: PromptModelConfigCreate;
};
export type PublishModelApiV1ModelModelIdPublishPostApiResponse = 
/** status 201 Successful Response */ PromptModel;
export type PublishModelApiV1ModelModelIdPublishPostApiArg = {
    modelId: string;
    promptModelPublish: PromptModelPublish;
};
export type GetPublishWorkflowApiV1ModelModelIdPublishGetApiResponse = 
/** status 200 Successful Response */ PromptModel;
export type GetPublishWorkflowApiV1ModelModelIdPublishGetApiArg = {
    modelId: string;
};
export type DeleteWorkflowApiV1ModelModelIdPublishDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteWorkflowApiV1ModelModelIdPublishDeleteApiArg = {
    modelId: string;
};
export type CreatePredictionWorkflowExternalApiV1ModelModelIdPredictPostApiResponse = 
/** status 201 Successful Response */ PromptModelWorkflow;
export type CreatePredictionWorkflowExternalApiV1ModelModelIdPredictPostApiArg = {
    modelId: string;
    promptModelWorkflowCreate: PromptModelWorkflowCreate;
};
export type GetAllPredictionForModelLastPublishApiV1ModelModelIdPredictGetApiResponse = 
/** status 200 Successful Response */ DynamoDbPagePromptModelWorkflow;
export type GetAllPredictionForModelLastPublishApiV1ModelModelIdPredictGetApiArg = {
    modelId: string;
    status?: PromptModelWorkflowDoneStatus[] | null;
    cursor?: string | null;
    pageSize?: number | "all";
};
export type GetPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdGetApiResponse = 
/** status 200 Successful Response */ PromptModelWorkflow;
export type GetPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdGetApiArg = {
    modelId: string;
    workflowId: string;
};
export type RerunPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdPatchApiResponse = 
/** status 201 Successful Response */ any;
export type RerunPredictionWorkflowApiV1ModelModelIdPredictWorkflowIdPatchApiArg = {
    modelId: string;
    workflowId: string;
    force?: boolean;
};
export type GetPredictionForDocumentApiV1ModelModelIdPredictEntityTypeEntityIdGetApiResponse = 
/** status 200 Successful Response */ PromptModelWorkflow;
export type GetPredictionForDocumentApiV1ModelModelIdPredictEntityTypeEntityIdGetApiArg = {
    modelId: string;
    entityType: ExternalEntityType;
    entityId: string;
};
export type SuspendPublishWorkflowApiV1ModelModelIdSuspendPatchApiResponse = 
/** status 201 Successful Response */ PromptModel;
export type SuspendPublishWorkflowApiV1ModelModelIdSuspendPatchApiArg = {
    modelId: string;
};
export type GetDocsInScopeApiV1ModelDocsInScopePostApiResponse = 
/** status 200 Successful Response */ PromptModelDocsInScope;
export type GetDocsInScopeApiV1ModelDocsInScopePostApiArg = {
    promptModelSearchScope: PromptModelSearchScope;
};
export type GenerateClauseApiV1ClauseGeneratePostApiResponse = 
/** status 200  */ ClauseGenerationResponse;
export type GenerateClauseApiV1ClauseGeneratePostApiArg = {
    clauseGenerationRequest: ClauseGenerationRequest;
};
export type RedlineClauseApiV1ClauseRedlinePostApiResponse = 
/** status 200  */ ClauseRedliningResponse;
export type RedlineClauseApiV1ClauseRedlinePostApiArg = {
    clauseRedliningRequest: ClauseRedliningRequest;
};
export type ListModelsInternalApiV1InternalModelGetApiResponse = 
/** status 200 Successful Response */ PagePromptModel;
export type ListModelsInternalApiV1InternalModelGetApiArg = {
    clientId: string;
    includeLatestVersion?: boolean;
    includePublishedVersion?: boolean;
    includeTestCases?: boolean;
    status?: PromptModelStatus | null;
    sortBy?: PromptModelSortByField | null;
    reverse?: boolean | null;
    /** Page number */
    page?: number;
    /** Page size */
    size?: number;
};
export type GetModelInternalViewApiV1InternalModelModelIdIdentityGetApiResponse = 
/** status 200 Successful Response */ PromptModelInternalView;
export type GetModelInternalViewApiV1InternalModelModelIdIdentityGetApiArg = {
    modelId: string;
    clientId: string;
    modelVersion?: number | null;
};
export type UpdateModelProgressInternalApiV1InternalModelModelIdProgressPatchApiResponse = 
/** status 204 Successful Response */ void;
export type UpdateModelProgressInternalApiV1InternalModelModelIdProgressPatchApiArg = {
    modelId: string;
    clientId: string;
};
export type TriggerInternalOptimizeApiV1InternalModelModelIdVersionVersionNumberOptimizePostApiResponse = 
/** status 202 Successful Response */ any;
export type TriggerInternalOptimizeApiV1InternalModelModelIdVersionVersionNumberOptimizePostApiArg = {
    modelId: string;
    versionNumber: number;
    clientId: string;
    userId?: string | null;
    userEmail?: string | null;
};
export type CreatePredictionWorkflowInternalApiV1InternalModelModelIdPredictPostApiResponse = 
/** status 201 Successful Response */ PromptModelWorkflow;
export type CreatePredictionWorkflowInternalApiV1InternalModelModelIdPredictPostApiArg = {
    modelId: string;
    clientId: string;
    userId?: string | null;
    userEmail?: string | null;
    reprocessCustomai?: boolean;
    promptModelWorkflowCreate: PromptModelWorkflowCreate;
};
export type CreateGroupPredictionWorkflowInternalApiV1InternalModelModelIdGroupPredictPostApiResponse = 
/** status 201 Successful Response */ PromptModelWorkflow;
export type CreateGroupPredictionWorkflowInternalApiV1InternalModelModelIdGroupPredictPostApiArg = {
    modelId: string;
    clientId: string;
    userId?: string | null;
    userEmail?: string | null;
    groupExecuteWorkflowCreate: GroupExecuteWorkflowCreate;
};
export type CheckDocInModelScopeApiV1InternalModelModelIdVersionVersionNumberCheckScopeGetApiResponse = 
/** status 200 Successful Response */ ScopeCheckResponse;
export type CheckDocInModelScopeApiV1InternalModelModelIdVersionVersionNumberCheckScopeGetApiArg = {
    modelId: string;
    versionNumber: number;
    clientId: string;
    entityId: string;
    entityType?: "document_handler";
};
export type GetModelSummaryForClientApiV1ModelsClientClientIdSummaryGetApiResponse = 
/** status 200 Successful Response */ PromptModelSummary;
export type GetModelSummaryForClientApiV1ModelsClientClientIdSummaryGetApiArg = {
    clientId: string;
};
export type GetLibraryModelsApiV1LibraryModelGetApiResponse = 
/** status 200 Successful Response */ DynamoDbPageApiLibraryModelVersion;
export type GetLibraryModelsApiV1LibraryModelGetApiArg = {
    pageSize?: number | null;
    cursor?: string | null;
};
export type CreateNewLibraryModelApiV1LibraryModelPostApiResponse = 
/** status 201 Successful Response */ ApiLibraryModelVersion;
export type CreateNewLibraryModelApiV1LibraryModelPostApiArg = {
    initialLibraryModelVersionCreate: InitialLibraryModelVersionCreate;
};
export type GetLibraryModelPublishStatusApiV1LibraryModelPublishGetApiResponse = 
/** status 200 Successful Response */ LibraryPublishResponse;
export type GetLibraryModelPublishStatusApiV1LibraryModelPublishGetApiArg = void;
export type PublishLibraryModelsApiV1LibraryModelPublishPostApiResponse = 
/** status 202 Successful Response */ LibraryPublishResponse;
export type PublishLibraryModelsApiV1LibraryModelPublishPostApiArg = {
    libraryPublishRequest: LibraryPublishRequest;
};
export type GetLibraryModelApiV1LibraryModelLibraryModelIdGetApiResponse = 
/** status 200 Successful Response */ GetLibraryModelResponse;
export type GetLibraryModelApiV1LibraryModelLibraryModelIdGetApiArg = {
    libraryModelId: string;
};
export type DeleteLibraryModelApiV1LibraryModelLibraryModelIdDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteLibraryModelApiV1LibraryModelLibraryModelIdDeleteApiArg = {
    libraryModelId: string;
};
export type GetLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberGetApiResponse = 
/** status 200 Successful Response */ ApiLibraryModelVersion;
export type GetLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberGetApiArg = {
    libraryModelId: string;
    libraryModelVersionNumber: string;
};
export type DeleteLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionLibraryModelVersionNumberDeleteApiArg = {
    libraryModelId: string;
    libraryModelVersionNumber: string;
};
export type CreateNewLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionPostApiResponse = 
/** status 201 Successful Response */ ApiLibraryModelVersion;
export type CreateNewLibraryModelVersionApiV1LibraryModelLibraryModelIdVersionPostApiArg = {
    libraryModelId: string;
    nextLibraryModelVersionCreate: NextLibraryModelVersionCreate;
};
export type CreateExtractionTableApiV1DdeTablesPostApiResponse = 
/** status 201 Successful Response */ DdeExtractionTable;
export type CreateExtractionTableApiV1DdeTablesPostApiArg = {
    ddeExtractionTableCreate: DdeExtractionTableCreate;
};
export type ListExtractionTablesApiV1DdeTablesGetApiResponse = 
/** status 200 Successful Response */ PageDdeExtractionTableListItem;
export type ListExtractionTablesApiV1DdeTablesGetApiArg = {
    /** Page number */
    page?: number;
    /** Page size */
    size?: number;
};
export type GetExtractionTableApiV1DdeTableTableIdGetApiResponse = 
/** status 200 Successful Response */ DdeExtractionTable;
export type GetExtractionTableApiV1DdeTableTableIdGetApiArg = {
    tableId: string;
};
export type RenameExtractionTableApiV1DdeTableTableIdPatchApiResponse = 
/** status 200 Successful Response */ DdeExtractionTable;
export type RenameExtractionTableApiV1DdeTableTableIdPatchApiArg = {
    tableId: string;
    ddeExtractionTableRename: DdeExtractionTableRename;
};
export type DeleteExtractionTableApiV1DdeTableTableIdDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteExtractionTableApiV1DdeTableTableIdDeleteApiArg = {
    tableId: string;
};
export type GetExtractionTableRowsApiV1DdeTableTableIdRowsGetApiResponse = 
/** status 200 Successful Response */ DdeExtractionTableRowsPage;
export type GetExtractionTableRowsApiV1DdeTableTableIdRowsGetApiArg = {
    tableId: string;
    page?: number;
    pageSize?: number;
};
export type AddDocumentsToExtractionTableApiV1DdeTableTableIdUploadPostApiResponse = 
/** status 204 Successful Response */ void;
export type AddDocumentsToExtractionTableApiV1DdeTableTableIdUploadPostApiArg = {
    tableId: string;
    searchScope: SearchScope;
};
export type RemoveDocumentsFromExtractionTableApiV1DdeTableTableIdDocumentHandlerIdDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type RemoveDocumentsFromExtractionTableApiV1DdeTableTableIdDocumentHandlerIdDeleteApiArg = {
    tableId: string;
    documentHandlerId: string;
};
export type CreateDdeModelInitialVersionApiV1DdeTableTableIdModelPostApiResponse = 
/** status 201 Successful Response */ DdeModelCreateResult;
export type CreateDdeModelInitialVersionApiV1DdeTableTableIdModelPostApiArg = {
    tableId: string;
    ddeModelCreate: DdeModelCreate;
};
export type ListDdeModelsApiV1DdeTableTableIdModelsGetApiResponse = 
/** status 200 Successful Response */ DdeModelListItem[];
export type ListDdeModelsApiV1DdeTableTableIdModelsGetApiArg = {
    tableId: string;
};
export type DeleteDdeModelApiV1DdeTableTableIdModelModelIdDeleteApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteDdeModelApiV1DdeTableTableIdModelModelIdDeleteApiArg = {
    tableId: string;
    modelId: string;
};
export type CreateDdeModelVersionApiV1DdeTableTableIdModelModelIdVersionPostApiResponse = 
/** status 201 Successful Response */ DdeModelVersion;
export type CreateDdeModelVersionApiV1DdeTableTableIdModelModelIdVersionPostApiArg = {
    tableId: string;
    modelId: string;
    ddeModelVersionCreate: DdeModelVersionCreate;
};
export type RunExtractionApiV1DdeTableTableIdExtractPostApiResponse = 
/** status 202 Successful Response */ DdeExtractionStartResponse;
export type RunExtractionApiV1DdeTableTableIdExtractPostApiArg = {
    tableId: string;
    modelId?: string | null;
};
export type FieldAiPocApiV1FieldAiPocGetApiResponse = 
/** status 200 Successful Response */ any;
export type FieldAiPocApiV1FieldAiPocGetApiArg = void;
export type FieldAiClassificationPocApiV1FieldAiClassificationPocGetApiResponse = 
/** status 200 Successful Response */ any;
export type FieldAiClassificationPocApiV1FieldAiClassificationPocGetApiArg = void;
export type TableExtractionPocApiV1TableExtractionPocGetApiResponse = 
/** status 200 Successful Response */ any;
export type TableExtractionPocApiV1TableExtractionPocGetApiArg = void;
export type HealthcheckHealthGetApiResponse = 
/** status 200 Successful Response */ HealthcheckResponse;
export type HealthcheckHealthGetApiArg = void;
export type HealthcheckHealthShallowGetApiResponse = 
/** status 200 Successful Response */ HealthcheckResponse;
export type HealthcheckHealthShallowGetApiArg = void;
export type AgentType = "ask_ai" | "ai_edit" | "ai_playbook" | "wf_router" | "playbook_builder" | "skill";
export type ExternalEntityType = "document_handler" | "document_version" | "document_external_id" | "field" | "document_id" | "all_documents" | "group" | "ticket" | "conversation_message" | "model" | "document_attached_data" | "agent_execution" | "ai_playbook_id" | "reference_playbook" | "reference_contract_template" | "reference_policy" | "example_contract";
export type ExternalEntity = {
    id: string;
    type: ExternalEntityType;
};
export type AgentConfiguration = {
    external_entities?: ExternalEntity[] | null;
    metadata?: {
        [key: string]: any;
    } | null;
};
export type ConversationRoles = "user" | "bot";
export type AgentMessageType = "query" | "command" | "followup" | "action" | "run_in_background" | "add_external_entities_and_run";
export type MessageContext = {
    /** Optional search query to limit scope. */
    search_query?: {
        [key: string]: any;
    }[] | null;
    /** Entity to be searched in search_query. */
    search_entity?: string | null;
    /** the selected pilot document_ids */
    selected_ids?: string[] | null;
    /** the selected entities for the scope. currently storing pilot doc handlers. */
    entities_in_view?: ExternalEntity[] | null;
    /** Type of message, ex: query, command... */
    message_type?: AgentMessageType | null;
};
export type HighlightRect = {
    x1: number;
    x2: number;
    y1: number;
    y2: number;
    width: number;
    height: number;
    pageNumber: number;
    pageRotation: number;
};
export type HightlightingRects = {
    rects: HighlightRect[];
    pageNumber: number;
};
export type HighlightingCoordinates = {
    source: string;
    coordinates: HightlightingRects;
    token_ids: number[];
};
export type DocumentHighlightSource = {
    name?: string;
    coordinates?: HighlightingCoordinates[] | null;
    html_tokens?: number[];
    text?: string | null;
};
export type Citation = {
    /** the data UI doc viewer needs in order to render the original_quote */
    highlights: DocumentHighlightSource[];
    /** the entity being cited */
    entity: ExternalEntity | null;
    /** the name of the entity being cited */
    entity_name?: string | null;
    /** UI url to render the citation */
    link: string | null;
    /** AiCitation -> AiCitationOptionalData -> tooltip */
    tooltip: string | null;
    /** AiCitation -> AiCitationOptionalData -> original_quote */
    original_quote: string | null;
    /** External document id for the cited document. */
    external_id?: string | null;
};
export type MessageActions = "convert_to_extraction_model" | "convert_to_classification_model" | "save_message" | "share_message";
export type UserRating = "positive" | "negative";
export type AgentExecutionMessage = {
    id: string;
    ae_id: string;
    role: ConversationRoles;
    message_text?: string | null;
    message_context: MessageContext | null;
    datetime_created: string;
    response_suggestions?: string[] | null;
    sources?: DocumentHighlightSource[];
    citations?: {
        [key: string]: Citation;
    };
    allowable_user_actions?: MessageActions[];
    user_rating?: UserRating | null;
    user_comment?: string | null;
    user_feedback_category?: string | null;
    /** Additional agent-specific data (e.g., workflow recommendations for WRA) */
    additional_info?: {
        [key: string]: any;
    };
};
export type AgentExecution = {
    id: string;
    datetime_created: string;
    created_by_user_id: string;
    created_by_user_email: string;
    agent_type: AgentType;
    agent_configuration: AgentConfiguration;
    execution_tag?: string | null;
    messages: AgentExecutionMessage[];
};
export type ValidationError = {
    loc: (string | number)[];
    msg: string;
    type: string;
    input?: any;
    ctx?: object;
};
export type HttpValidationError = {
    detail?: ValidationError[];
};
export type AgentConfiguration2 = {
    external_entities?: ExternalEntity[] | null;
    metadata?: {
        [key: string]: any;
    } | null;
};
export type NewAgentExecutionRequest = {
    agent_type: AgentType;
    agent_configuration: AgentConfiguration2;
    execution_tag?: string | null;
};
export type PageAgentExecution = {
    items: AgentExecution[];
    total: number;
    page: number;
    size: number;
    pages: number;
};
export type MessageContext2 = {
    /** Optional search query to limit scope. */
    search_query?: {
        [key: string]: any;
    }[] | null;
    /** Entity to be searched in search_query. */
    search_entity?: string | null;
    /** the selected pilot document_ids */
    selected_ids?: string[] | null;
    /** the selected entities for the scope. currently storing pilot doc handlers. */
    entities_in_view?: ExternalEntity[] | null;
    /** Type of message, ex: query, command... */
    message_type?: AgentMessageType | null;
};
export type AgentExecutionMessageRequest = {
    /** Text of the message to send to the AI. Maximum length is 1000 words / 10000 characters. */
    message: string;
    context: MessageContext2;
    metadata?: {
        [key: string]: any;
    };
};
export type AgentExecutionStreamEventType = "thinking" | "message_context" | "message_start" | "message_delta" | "message" | "message_response_suggestion" | "message_source" | "message_end" | "stream_end" | "message_citations";
export type AgentExecutionStreamEvent = {
    event_type: AgentExecutionStreamEventType;
    text?: string | null;
    message?: AgentExecutionMessage | null;
    message_context?: MessageContext | null;
};
export type UpdateAgentExecutionMessageRequest = {
    user_rating?: UserRating | null;
    user_comment?: string | null;
    user_feedback_category?: string | null;
};
export type ConversationMessageSource = {
    name?: string;
    coordinates?: HighlightingCoordinates[] | null;
    html_tokens?: number[];
    text?: string | null;
};
export type ConversationMessage = {
    id: string;
    conversation_id: string;
    role: ConversationRoles;
    message_text: string;
    message_context?: MessageContext[];
    datetime_created: string;
    response_suggestions?: string[] | null;
    sources?: ConversationMessageSource[];
    citations?: {
        [key: string]: Citation;
    };
    allowable_user_actions?: MessageActions[];
    user_rating?: UserRating | null;
    user_comment?: string | null;
    user_feedback_category?: string | null;
    /** Additional agent-specific data (e.g., workflow recommendations for WRA) */
    additional_info?: {
        [key: string]: any;
    };
};
export type ConversationMetadata = {
    document_hash: string;
};
export type InternalEntityType = "evisort_document" | "all_documents" | "ticket" | "model" | "agent_execution";
export type InternalEntity = {
    internal_entity_id?: string | null;
    source_entity: ExternalEntity;
    refetch_entity: ExternalEntity;
    internal_entity_type: InternalEntityType;
    index_key: string;
    metadata?: {
        [key: string]: string;
    };
    content: any;
};
export type AgentStatus = "initializing" | "running" | "completed" | "error" | "unknown";
export type Conversation = {
    id: string;
    datetime_created: string;
    datetime_modified?: string | null;
    created_by_user_id: string;
    created_by_user_email: string;
    title?: string | null;
    version?: number;
    messages: ConversationMessage[];
    metadata?: ConversationMetadata | null;
    entities?: InternalEntity[];
    agent_configuration?: AgentConfiguration | null;
    agent_type?: AgentType | null;
    agent_status?: AgentStatus | null;
    agent_error_message?: string | null;
};
export type NewConversationRequest = {
    entities?: ExternalEntity[] | null;
};
export type UpdateConversationRequest = {
    /** Conversation title. Maximum length is 100 characters. */
    title: string;
    version: number;
};
export type SendConversationMessageRequest = {
    /** Text of the message to send to the AI. Maximum length is 1000 words / 10000 characters. */
    message: string;
    context?: MessageContext2[];
    metadata?: {
        [key: string]: string;
    };
};
export type AiMessageResponse = {
    response_messages: ConversationMessage[];
};
export type ConversationStreamEventType = "thinking" | "message_context" | "message_start" | "message_delta" | "message" | "message_response_suggestion" | "message_source" | "message_end" | "stream_end" | "message_citations";
export type ConversationStreamEvent = {
    event_type: ConversationStreamEventType;
    text?: string | null;
    message?: ConversationMessage | null;
    message_context?: MessageContext[] | null;
};
export type UpdateConversationMessageRequest = {
    user_rating?: UserRating | null;
    user_comment?: string | null;
    user_feedback_category?: string | null;
};
export type User = {
    user_id: string;
    client_id: string;
    email: string;
    name: string;
    accept_disclaimer: boolean;
    datetime_accept_disclaimer: string;
    datetime_last_access?: string | null;
};
export type PromptModelExternalEntity = {
    id: string;
    type: "field" | "document_attached_data";
};
export type TargetEntityResponseItem = {
    prompt_model_id: string;
    target_entity: PromptModelExternalEntity;
};
export type PageTargetEntityResponseItem = {
    items: TargetEntityResponseItem[];
    total: number;
    page: number;
    size: number;
    pages: number;
};
export type DynamoDbPageTargetEntityResponseItem = {
    items: TargetEntityResponseItem[];
    cursor?: string | null;
};
export type FieldClassificationConfigOutput = {
    [key: string]: any;
};
export type FieldExtractionConfigOutput = {
    [key: string]: any;
};
export type TableExtractionConfigOutput = {
    [key: string]: any;
};
export type PromptModelConfig = ({
    prompt_model_type: "field_classification";
} & FieldClassificationConfigOutput) | ({
    prompt_model_type: "field_extraction";
} & FieldExtractionConfigOutput) | ({
    prompt_model_type: "table_extraction";
} & TableExtractionConfigOutput);
export type PromptModelTestCaseEntity = {
    id: string;
    type: "document_version" | "document_handler";
};
export type TestCaseState = "not_started" | "queued" | "running" | "error" | "done";
export type TestCaseOutcome = "unknown" | "correct" | "partially_correct" | "incorrect" | "skipped";
export type FieldValueSource = {
    /** The source of the field value. (Just the _value_ itself, not the context). */
    value?: DocumentHighlightSource | null;
    /** The source of the field value, including context. */
    context?: DocumentHighlightSource | null;
    /** Whether the source was generated by the AI model, or by the user. This is used to determine which sources to include when creating the final field value. */
    generated_by?: "ai" | "user" | "unknown";
    /** For grouped document execution: the member document_version_id where the highlight coordinates apply. Null for single-doc execution. */
    source_document_version_id?: string | null;
};
export type StringFieldValue = {
    output_type?: "field_value";
    value: string | null;
    value_type?: "string";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource[];
};
export type ClassificationModelOutput = {
    output_type?: "string";
    /** The classification values extracted by the model. */
    value?: string[];
    value_type?: "classification";
    /** Classification results as field values */
    field_values?: StringFieldValue[];
    /** The source for all the classification field values. */
    sources?: FieldValueSource[];
};
export type DatetimeFieldValue = {
    output_type?: "field_value";
    value: string | null;
    value_type?: "datetime";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource[];
};
export type FloatFieldValue = {
    output_type?: "field_value";
    value: string | null;
    value_type?: "float";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource[];
};
export type IntFieldValue = {
    output_type?: "field_value";
    value: number | null;
    value_type?: "int";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource[];
};
export type TableColumnSpec = {
    /** the name of the column */
    name: string;
    /** The type of the column */
    column_type: "string" | "text_area" | "int" | "float" | "datetime";
    /** A description of the column */
    description?: string | null;
};
export type TableSpec = {
    /** the collection of column definitions */
    columns: TableColumnSpec[];
    /** the name of the table */
    name?: string;
};
export type DatetimeTableCell = {
    cell_id?: string | null;
    value?: string | number | string | string | null;
    value_type?: "datetime";
    /** The source of the table cell value. (Just the _value_ itself, not the context). */
    source?: DocumentHighlightSource | null;
    /** For grouped table extraction: the version_id of the member document this cell's source page number resolved to. None for single-document table extraction, or when the cell has no source / its page number doesn't resolve to any member. */
    source_document_version_id?: string | null;
};
export type FloatTableCell = {
    cell_id?: string | null;
    value?: string | number | string | string | null;
    value_type?: "float";
    /** The source of the table cell value. (Just the _value_ itself, not the context). */
    source?: DocumentHighlightSource | null;
    /** For grouped table extraction: the version_id of the member document this cell's source page number resolved to. None for single-document table extraction, or when the cell has no source / its page number doesn't resolve to any member. */
    source_document_version_id?: string | null;
};
export type IntTableCell = {
    cell_id?: string | null;
    value?: string | number | string | string | null;
    value_type?: "int";
    /** The source of the table cell value. (Just the _value_ itself, not the context). */
    source?: DocumentHighlightSource | null;
    /** For grouped table extraction: the version_id of the member document this cell's source page number resolved to. None for single-document table extraction, or when the cell has no source / its page number doesn't resolve to any member. */
    source_document_version_id?: string | null;
};
export type StringTableCell = {
    cell_id?: string | null;
    value?: string | number | string | string | null;
    value_type?: "string" | "text_area";
    /** The source of the table cell value. (Just the _value_ itself, not the context). */
    source?: DocumentHighlightSource | null;
    /** For grouped table extraction: the version_id of the member document this cell's source page number resolved to. None for single-document table extraction, or when the cell has no source / its page number doesn't resolve to any member. */
    source_document_version_id?: string | null;
};
export type TableRow = {
    cells: (({
        value_type: "datetime";
    } & DatetimeTableCell) | ({
        value_type: "float";
    } & FloatTableCell) | ({
        value_type: "int";
    } & IntTableCell) | ({
        value_type: "string";
    } & StringTableCell) | ({
        value_type: "text_area";
    } & StringTableCell))[];
};
export type TableValue = {
    value_type?: "table_value";
    output_type?: "table_value";
    table_value_version?: string;
    spec: TableSpec;
    value: TableRow[];
    was_truncated?: boolean;
};
export type TextAreaFieldValue = {
    output_type?: "field_value";
    value: string | null;
    value_type?: "text_area";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource[];
};
export type UnknownWithSources = {
    output_type?: string;
    value?: null;
    value_type?: "unknown";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource[];
};
export type FullPromptModelTestCaseIdentifier = {
    prompt_model_id: string;
    prompt_model_version_number: number;
    number: number;
};
export type PromptModelTestCase = {
    number: number;
    prompt_model_id: string;
    prompt_model_version_number: number;
    datetime_created: string;
    datetime_updated: string;
    created_by_user_id: string;
    created_by_user_email: string;
    entity: PromptModelTestCaseEntity;
    state?: TestCaseState;
    outcome?: TestCaseOutcome;
    promptmodel_value?: (({
        value_type: "classification";
    } & ClassificationModelOutput) | ({
        value_type: "datetime";
    } & DatetimeFieldValue) | ({
        value_type: "float";
    } & FloatFieldValue) | ({
        value_type: "int";
    } & IntFieldValue) | ({
        value_type: "string";
    } & StringFieldValue) | ({
        value_type: "table_value";
    } & TableValue) | ({
        value_type: "text_area";
    } & TextAreaFieldValue) | ({
        value_type: "unknown";
    } & UnknownWithSources)) | null;
    gold_value?: (({
        value_type: "classification";
    } & ClassificationModelOutput) | ({
        value_type: "datetime";
    } & DatetimeFieldValue) | ({
        value_type: "float";
    } & FloatFieldValue) | ({
        value_type: "int";
    } & IntFieldValue) | ({
        value_type: "string";
    } & StringFieldValue) | ({
        value_type: "table_value";
    } & TableValue) | ({
        value_type: "text_area";
    } & TextAreaFieldValue) | ({
        value_type: "unknown";
    } & UnknownWithSources)) | null;
    user_feedback?: string | null;
    llm_output?: {
        [key: string]: any;
    } | null;
    copied_from?: FullPromptModelTestCaseIdentifier | null;
};
export type PromptModelPublishStatus = "in_progress" | "suspended" | "resumed" | "completed" | "failed";
export type PromptModelPublishInfo = {
    version_number?: number | null;
    datetime_published?: string | null;
    published_by_user_id?: string | null;
    published_by_user_email?: string | null;
    status?: PromptModelPublishStatus | null;
    workflow_id?: string | null;
};
export type OptimizeState = "initializing" | "running" | "error" | "done";
export type PromptModelOptimizationInfo = {
    optimize_run_id: string;
    version_number: number;
    state: OptimizeState;
    total_test_cases?: number | null;
};
export type LibraryModelInfo = {
    library_model_id: string;
    library_model_version: string;
};
export type PromptModelVersion = {
    prompt_model_id: string;
    version_number: number;
    datetime_created: string;
    created_by_user_id: string;
    created_by_user_email: string;
    config: PromptModelConfig;
    test_case_numbers?: number[];
    test_cases?: {
        [key: string]: PromptModelTestCase;
    };
    publish?: PromptModelPublishInfo | null;
    optimize?: PromptModelOptimizationInfo | null;
    /** If this model was created from a library model, this field will contain the library model info. */
    library_model_info?: LibraryModelInfo | null;
};
export type PromptModel = {
    id: string;
    client_id: string;
    datetime_created: string;
    datetime_updated: string;
    datetime_deleted?: string | null;
    created_by_user_id: string;
    created_by_user_email: string;
    target_entity: PromptModelExternalEntity;
    version_numbers?: number[];
    versions?: {
        [key: string]: PromptModelVersion;
    };
    published_version_number?: number | null;
    published_workflow_id?: string | null;
    current_publish?: PromptModelPublishInfo | null;
    current_optimize?: PromptModelOptimizationInfo | null;
    suspended?: boolean | null;
    stats?: {
        [key: string]: any;
    } | null;
    publish_status?: string | null;
    last_scan_workflow_id?: string | null;
    /** If this model was created from a library model, this field will indicate which one */
    library_model_info?: LibraryModelInfo | null;
};
export type PromptModelCreate = {
    target_entity: PromptModelExternalEntity;
};
export type PagePromptModel = {
    items: PromptModel[];
    total: number;
    page: number;
    size: number;
    pages: number;
};
export type PromptModelStatus = "draft" | "published" | "suspended" | "deleted" | "deleted_after_published";
export type PromptModelSortByField = "docsInScope" | "valuesFound" | "modifiedDate" | "publishStatus";
export type PromptModelSummary = {
    total: number;
    draft: number;
    published: number;
    suspended: number;
    deleted: number;
    deleted_after_published: number;
    consumed_quota: number;
    total_quota: number;
};
export type PromptModelProgress = {
    docs_in_scope: number;
    current_publish_status?: PromptModelPublishStatus | null;
    /** Number of document processed so far. If null, the model is not published */
    docs_processed?: number | null;
    /** Number of values found so far. If null, the model is not published */
    values_found?: number | null;
    /** Number of documents that failed to process. If null, the model is not published */
    docs_failed?: number | null;
    dirty?: boolean | null;
    current_optimize_state?: OptimizeState | null;
};
export type DocFilter = {
    type: "document_handler" | "document_version";
    ids: number[];
};
export type SearchScopeAttributes = {
    query: {
        [key: string]: any;
    }[];
    filters: string[];
    doc_filter?: DocFilter;
    store_as_recent_search: boolean;
    restrict_by_contract_types_from_field_id?: string;
    restrict_by_file_types?: string;
};
export type SearchScope = {
    type: "document";
    data: {
        [key: string]: SearchScopeAttributes;
    };
};
export type ClassificationOption = {
    /** The display label for the option choice */
    label: string;
    /** The stored value for the option choice */
    value: string;
    /** A user readable description of the option choice */
    description?: string;
};
export type FieldClassificationConfigCreate = {
    prompt_model_type?: "field_classification";
    input_type?: "evisort_document";
    output_type?: "string";
    scope?: SearchScope;
    internal?: string | null;
    instructions?: string;
    /** A description of the field to be extracted or classified. */
    field_description?: string;
    /** The name of the field to be extracted or classified. This is frozen at the time the version is created and updates to field names do not change it. It is not used to lookup the field in external services, but only used internally in prompts sent to the AI model. */
    field_name: string;
    value_type?: "classification";
    options?: ClassificationOption[];
    is_multi?: boolean;
    allow_additional_options?: boolean;
    default_option?: ClassificationOption | null;
};
export type StringMatchingLevel = 0 | 1 | 2 | 3 | 4;
export type FieldExtractionConfigCreate = {
    prompt_model_type?: "field_extraction";
    input_type?: "evisort_document";
    output_type: "string" | "text_area" | "int" | "float" | "datetime";
    scope?: SearchScope;
    internal?: string | null;
    instructions?: string;
    /** A description of the field to be extracted or classified. */
    field_description?: string;
    /** The name of the field to be extracted or classified. This is frozen at the time the version is created and updates to field names do not change it. It is not used to lookup the field in external services, but only used internally in prompts sent to the AI model. */
    field_name: string;
    /** How exact matches need to be when evaluating correct output.
      | Level | Description |
      |-------|-------------|
      | `0` | The extracted value must be an exact match to the gold value |
      | `1` | The extracted value must match except for punctuation |
      | `2` | The extracted value must match 90% of the text |
      | `3` | The extracted value must match 90% of the words |
      | `4` | The extracted value must be the same as the gold value according to the LLM model |
      
      NOTE: only relevant when evaluating `string`/`text_area` fields.
       */
    string_matching_level?: StringMatchingLevel;
    /** Optional instructions for reformatting the extracted value.
      For non-text fields, this is not editable by the user and the defaults will be used
      However, for text fields the user can specify this behavior */
    reformatting_instructions?: string | null;
};
export type TableExtractionConfigCreate = {
    prompt_model_type?: "table_extraction";
    input_type?: "evisort_document";
    output_type?: "table_value";
    scope?: SearchScope;
    internal?: string | null;
    instructions?: string;
    /** The schema definition for the table to be extracted. */
    table_spec: TableSpec;
};
export type PromptModelConfigCreate = ({
    prompt_model_type: "field_classification";
} & FieldClassificationConfigCreate) | ({
    prompt_model_type: "field_extraction";
} & FieldExtractionConfigCreate) | ({
    prompt_model_type: "table_extraction";
} & TableExtractionConfigCreate);
export type PromptModelVersionCreateFromConfig = {
    config: PromptModelConfigCreate;
};
export type PromptModelVersionCreateFromLibrary = {
    library_model_id: string;
    library_model_version: string;
};
export type HighlightingCoordinates2 = {
    source: string;
    coordinates: HightlightingRects;
    token_ids: number[];
};
export type DocumentHighlightSource2 = {
    name?: string;
    coordinates?: HighlightingCoordinates2[] | null;
    html_tokens?: number[];
    text?: string | null;
};
export type FieldValueSource2 = {
    /** The source of the field value. (Just the _value_ itself, not the context). */
    value?: DocumentHighlightSource2 | null;
    /** The source of the field value, including context. */
    context?: DocumentHighlightSource2 | null;
    /** Whether the source was generated by the AI model, or by the user. This is used to determine which sources to include when creating the final field value. */
    generated_by?: "ai" | "user" | "unknown";
    /** For grouped document execution: the member document_version_id where the highlight coordinates apply. Null for single-doc execution. */
    source_document_version_id?: string | null;
};
export type StringFieldValue2 = {
    output_type?: "field_value";
    value: string | null;
    value_type?: "string";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource2 | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource2[];
};
export type ClassificationModelOutput2 = {
    output_type?: "string";
    /** The classification values extracted by the model. */
    value?: string[];
    value_type?: "classification";
    /** Classification results as field values */
    field_values?: StringFieldValue2[];
    /** The source for all the classification field values. */
    sources?: FieldValueSource2[];
};
export type DatetimeFieldValue2 = {
    output_type?: "field_value";
    value: string | null;
    value_type?: "datetime";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource2 | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource2[];
};
export type FloatFieldValue2 = {
    output_type?: "field_value";
    value: number | string | null;
    value_type?: "float";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource2 | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource2[];
};
export type IntFieldValue2 = {
    output_type?: "field_value";
    value: number | null;
    value_type?: "int";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource2 | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource2[];
};
export type DatetimeTableCell2 = {
    cell_id?: string | null;
    value?: string | null;
    value_type?: "datetime";
    /** The source of the table cell value. (Just the _value_ itself, not the context). */
    source?: DocumentHighlightSource2 | null;
    /** For grouped table extraction: the version_id of the member document this cell's source page number resolved to. None for single-document table extraction, or when the cell has no source / its page number doesn't resolve to any member. */
    source_document_version_id?: string | null;
};
export type FloatTableCell2 = {
    cell_id?: string | null;
    value?: number | string | null;
    value_type?: "float";
    /** The source of the table cell value. (Just the _value_ itself, not the context). */
    source?: DocumentHighlightSource2 | null;
    /** For grouped table extraction: the version_id of the member document this cell's source page number resolved to. None for single-document table extraction, or when the cell has no source / its page number doesn't resolve to any member. */
    source_document_version_id?: string | null;
};
export type IntTableCell2 = {
    cell_id?: string | null;
    value?: number | null;
    value_type?: "int";
    /** The source of the table cell value. (Just the _value_ itself, not the context). */
    source?: DocumentHighlightSource2 | null;
    /** For grouped table extraction: the version_id of the member document this cell's source page number resolved to. None for single-document table extraction, or when the cell has no source / its page number doesn't resolve to any member. */
    source_document_version_id?: string | null;
};
export type StringTableCell2 = {
    cell_id?: string | null;
    value?: string | null;
    value_type?: "string" | "text_area";
    /** The source of the table cell value. (Just the _value_ itself, not the context). */
    source?: DocumentHighlightSource2 | null;
    /** For grouped table extraction: the version_id of the member document this cell's source page number resolved to. None for single-document table extraction, or when the cell has no source / its page number doesn't resolve to any member. */
    source_document_version_id?: string | null;
};
export type TableRow2 = {
    cells: (({
        value_type: "datetime";
    } & DatetimeTableCell2) | ({
        value_type: "float";
    } & FloatTableCell2) | ({
        value_type: "int";
    } & IntTableCell2) | ({
        value_type: "string";
    } & StringTableCell2) | ({
        value_type: "text_area";
    } & StringTableCell2))[];
};
export type TableValue2 = {
    value_type?: "table_value";
    output_type?: "table_value";
    table_value_version?: string;
    spec: TableSpec;
    value: TableRow2[];
    was_truncated?: boolean;
};
export type TextAreaFieldValue2 = {
    output_type?: "field_value";
    value: string | null;
    value_type?: "text_area";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource2 | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource2[];
};
export type UnknownWithSources2 = {
    output_type?: string;
    value?: null;
    value_type?: "unknown";
    /** Single, combined source for this field value. This represents the highlight that would be used to create the final field value in the FVS, and used for highlighting in the document viewer post-publish. Typically created by merging the individual sources in the `sources` field. */
    source?: FieldValueSource2 | null;
    /** The sources for this field value. These are the individual sources that the AI model indicated as contributing to the final field value. These are not sent to the FVS, but can be used to provide additional context when interacting with the model results via the sylvanus API. If the field value was generated from _before_ the sources were added, this field will be a list with a single source, which is identical to the `source` field. */
    sources?: FieldValueSource2[];
};
export type PromptModelTestCaseFeedback = {
    outcome: TestCaseOutcome;
    gold_value?: (({
        value_type: "classification";
    } & ClassificationModelOutput2) | ({
        value_type: "datetime";
    } & DatetimeFieldValue2) | ({
        value_type: "float";
    } & FloatFieldValue2) | ({
        value_type: "int";
    } & IntFieldValue2) | ({
        value_type: "string";
    } & StringFieldValue2) | ({
        value_type: "table_value";
    } & TableValue2) | ({
        value_type: "text_area";
    } & TextAreaFieldValue2) | ({
        value_type: "unknown";
    } & UnknownWithSources2)) | null;
    user_feedback?: string | null;
};
export type PromptModelTestCaseExecuteResponse = {
    stream_id: string;
};
export type Progress = {
    total: number;
    completed: number;
};
export type OptimizeTestCase = {
    outcome: TestCaseOutcome;
    /** The value extracted by the model. Only null if the testcase errored. */
    promptmodel_value?: (({
        value_type: "classification";
    } & ClassificationModelOutput) | ({
        value_type: "datetime";
    } & DatetimeFieldValue) | ({
        value_type: "float";
    } & FloatFieldValue) | ({
        value_type: "int";
    } & IntFieldValue) | ({
        value_type: "string";
    } & StringFieldValue) | ({
        value_type: "table_value";
    } & TableValue) | ({
        value_type: "text_area";
    } & TextAreaFieldValue) | ({
        value_type: "unknown";
    } & UnknownWithSources)) | null;
    number: number;
    entity: PromptModelTestCaseEntity;
};
export type ResultTag = "original" | "best_overall" | "best_strictly_better" | "best_no_user_config_changes" | "best_upgradable_safe";
export type OptimizeResultStats = {
    /** Total number of test cases */
    total: number;
    /** Change in number of correct test cases */
    delta_correct: number;
    /** Number of correct test cases */
    correct: number;
    /** Number of partially correct test cases */
    partially_correct: number;
    /** Number of incorrect test cases */
    incorrect: number;
    /** Number of test cases that the base config got correct and the new config got incorrect */
    correct_to_incorrect: number;
    /** Number of test cases that errored */
    error: number;
};
export type OptimizeResultsForConfig = {
    /** The configuration for the optimized model */
    config: PromptModelConfig;
    test_cases: {
        [key: string]: OptimizeTestCase;
    };
    /** The tag for the result, indicating why it was chosen as an optimal config:
      - `best_overall`: The best result overall
      - `best_strictly_better`: The best result that is strictly better than the base config
      - `best_no_user_config_changes`: The best result with no user config changes (e.g. instructions)
      - `best_upgradable_safe`: Best safe upgrade prefers best config with no user config changes
      
      Note that more tags may be added in future.
       */
    tag: ResultTag;
    /** Stats for the optimized model */
    stats: OptimizeResultStats;
    /** The unique key for the configuration in the optimization run */
    config_key: string;
    /** Whether or not this config has changes from the the base config that are visible to the user */
    no_user_config_changes: boolean;
};
export type OptimizeRunMode = "standard" | "silent_boost";
export type OptimizeRun = {
    id: string;
    prompt_model_id: string;
    prompt_model_version_number: number;
    datetime_created: string;
    datetime_updated: string;
    created_by_user_id: string | null;
    created_by_user_email: string | null;
    /** The state of the optimization run. Will progress like so:
      ```plaintext
      initializing -> running -> error | done
      ``` */
    state: OptimizeState;
    /** The progress of the optimization run. `null` until the run enters the `running` state */
    progress?: Progress | null;
    /** The gold values for the test cases. Correspond to the test cases in the `test_cases` field. These are the values that the user has marked as correct, partially correct, or incorrect */
    gold_values: {
        [key: string]: ({
            value_type: "classification";
        } & ClassificationModelOutput) | ({
            value_type: "datetime";
        } & DatetimeFieldValue) | ({
            value_type: "float";
        } & FloatFieldValue) | ({
            value_type: "int";
        } & IntFieldValue) | ({
            value_type: "string";
        } & StringFieldValue) | ({
            value_type: "table_value";
        } & TableValue) | ({
            value_type: "text_area";
        } & TextAreaFieldValue) | ({
            value_type: "unknown";
        } & UnknownWithSources);
    };
    /** The results for the original model configuration. */
    original_results: OptimizeResultsForConfig;
    /** The optimized results for the run. Will contain 1-4 results, in the order:
      - the best result with no user config changes
      - the best result that is strictly better than the base config
      - the best result overall
      - the best safe upgrade
      This ordering may change in future. When rendering these results clients should use the `tag` field to
      determine how to label each result, rather than relying on the order in this list",
       */
    results?: OptimizeResultsForConfig[] | null;
    /** The mode of optimization run. Will be `standard` for user-initiated optimization runs, and `silent_boost` for silent boosts. */
    run_mode?: OptimizeRunMode;
};
export type FieldClassificationConfigCreateOutput = {
    [key: string]: any;
};
export type FieldExtractionConfigCreateOutput = {
    [key: string]: any;
};
export type TableExtractionConfigCreateOutput = {
    [key: string]: any;
};
export type PromptModelConfigCreate2 = ({
    prompt_model_type: "field_classification";
} & FieldClassificationConfigCreateOutput) | ({
    prompt_model_type: "field_extraction";
} & FieldExtractionConfigCreateOutput) | ({
    prompt_model_type: "table_extraction";
} & TableExtractionConfigCreateOutput);
export type PromptModelConfigSuggestResponse = {
    config: PromptModelConfigCreate2;
    is_best: boolean;
};
export type FieldConfigSuggestRequest = {
    /** A question, an instruction, or elaboration on the field. Optional if `field_name` is given. */
    instructions?: string | null;
    /** An explicit field name. Optional if `instructions` is given. */
    field_name?: string | null;
};
export type PromptModelPublishMode = "all_docs_in_scope" | "new_docs_in_scope";
export type PromptModelPublish = {
    published_version_number: number;
    idempotency_key: string;
    publish_mode?: PromptModelPublishMode;
};
export type PromptModelWorkflowState = "new" | "pending" | "predicting" | "committing" | "completed" | "failed" | "aborted" | "suspended" | "resumed";
export type PromptModelWorkflowType = "prediction" | "publish" | "optimize_before_publish" | "group_prediction";
export type PromptModelWorkflow = {
    id: string;
    client_id: string;
    prompt_model_version: PromptModelVersion;
    datetime_created: string;
    datetime_updated: string;
    state: PromptModelWorkflowState;
    workflow_type: PromptModelWorkflowType;
    created_by_user_id?: string | null;
    created_by_user_email?: string | null;
    execution_arn?: string | null;
    entity?: ExternalEntity | null;
    reservation_id?: string | null;
    datetime_deleted?: string | null;
    stats?: {
        [key: string]: any;
    } | null;
    prompt_model_id?: string | null;
    output?: (({
        value_type: "classification";
    } & ClassificationModelOutput) | ({
        value_type: "datetime";
    } & DatetimeFieldValue) | ({
        value_type: "float";
    } & FloatFieldValue) | ({
        value_type: "int";
    } & IntFieldValue) | ({
        value_type: "string";
    } & StringFieldValue) | ({
        value_type: "table_value";
    } & TableValue) | ({
        value_type: "text_area";
    } & TextAreaFieldValue) | ({
        value_type: "unknown";
    } & UnknownWithSources)) | null;
    metadata?: {
        [key: string]: any;
    } | null;
    context?: {
        [key: string]: any;
    } | null;
};
export type PromptModelWorkflowCreate = {
    prompt_model_version_number?: number | null;
    entity?: ExternalEntity | null;
    is_pending_index?: boolean | null;
    publish_mode?: PromptModelPublishMode;
};
export type DynamoDbPagePromptModelWorkflow = {
    items: PromptModelWorkflow[];
    cursor?: string | null;
};
export type PromptModelWorkflowDoneStatus = "found" | "not_found" | "failed" | "aborted";
export type PromptModelDocsInScope = {
    docs_in_scope: number;
};
export type PromptModelSearchScope = {
    target_entity: PromptModelExternalEntity;
    scope: SearchScope;
};
export type ClauseGenerationResponse = {
    id?: string;
    text: string;
};
export type ClauseGenerationRequest = {
    instructions: string;
    static?: boolean;
};
export type ClauseRedliningResponse = {
    id?: string;
    text: string;
};
export type ClauseRedliningRequest = {
    text: string;
    instructions: string;
    static?: boolean;
};
export type PromptModelInternalView = {
    id: string;
    entity_name?: string | null;
    model_entity_type?: ("field_extraction" | "field_classification" | "table_extraction") | null;
    llm_version?: string | null;
    model_version_number?: number | null;
    status: PromptModelStatus;
};
export type GroupEntityMetadata = {
    is_primary?: boolean;
    document_type?: string | null;
    document_name?: string | null;
};
export type GroupExecuteMemberEntity = {
    id: string;
    type?: "document_version";
    metadata?: GroupEntityMetadata;
};
export type GroupedEvisortDocumentModelInputMetadata = {
    /** Version ID of the group document (for storing group output in FVS) */
    group_document_version_id: string;
    instructions?: string | null;
};
export type GroupExecuteWorkflowCreate = {
    /** MES generated group id */
    group_id: string;
    prompt_model_version_number?: number | null;
    entities: GroupExecuteMemberEntity[];
    metadata: GroupedEvisortDocumentModelInputMetadata;
};
export type ScopeCheckResponse = {
    in_scope: boolean;
    retry?: boolean;
};
export type LinkedModelInfo = {
    publish_status: PromptModelPublishStatus | null;
    prompt_model_id: string;
};
export type LibrarySampleOutputs = {
    /** Sample outputs for the model, in markdown format. */
    text?: string;
    /** Sample dashboard chart data for the model. Sylvanus does not enforce any schema here, FE is responsible for structuring the data. */
    dashboard?: {
        [key: string]: any;
    } | null;
};
export type LibraryTag = {
    tag_type: ("category" | "industry" | "contract_type") | string;
    tag_value: string;
};
export type DocumentAttachedDataTargetInformation = {
    entity_type?: "document_attached_data";
    /** The key of the attached data to target. */
    target_attached_data_key: string;
};
export type FieldTargetInformation = {
    entity_type?: "field";
    value_type: ("string" | "text_area" | "int" | "float" | "datetime") | "classification";
};
export type ApiLibraryModelVersion = {
    /**
      List of linked prompt models for the library model version. Note that in general this should at most have one entry,
      but it's technically possible to have multiple linked models in certain rare cases.
      
      Also to keep this API general going into the future, it's better to allow multiple model linkages in the API.
      
      Some notes about meaning of certain values for this field:
      - `linked_models == []` ==> there are no linked prompt models
      - `linked_models[0].publish_status == None` ==> the linked prompt model has not been published yet
       */
    linked_models?: LinkedModelInfo[];
    /** Some models may require certain field names to exist in the client. If this field is present, it indicates that these fields are missing and the scope has been reset */
    scope_errors?: string[];
    /** ID of the model. Links together all versions of the same model. */
    library_model_id: string;
    /** Version number of the model. */
    version: string;
    /** Whether this is the latest version of the model. */
    latest: boolean;
    /** Date and time the record was created. */
    datetime_created: string;
    /** Date and time the record was deleted, if applicable. */
    datetime_deleted?: string | null;
    /** Name of the model. */
    name: string;
    /** Description of the model. */
    description: string;
    /** Sample outputs for the model, in markdown format. */
    sample_outputs: LibrarySampleOutputs;
    /** Tags for the model. */
    tags?: LibraryTag[];
    /** Changes since previous version */
    changelog_entry: string;
    /** Target information for the model. */
    target: ({
        entity_type: "document_attached_data";
    } & DocumentAttachedDataTargetInformation) | ({
        entity_type: "field";
    } & FieldTargetInformation);
    /** Configuration for the model. */
    configuration: PromptModelConfig;
};
export type DynamoDbPageApiLibraryModelVersion = {
    items: ApiLibraryModelVersion[];
    cursor?: string | null;
};
export type FieldClassificationConfig = {
    prompt_model_type?: "field_classification";
    input_type?: "evisort_document";
    output_type?: "string";
    scope?: SearchScope;
    internal: string;
    instructions?: string;
    /** A description of the field to be extracted or classified. */
    field_description?: string;
    /** The name of the field to be extracted or classified. This is frozen at the time the version is created and updates to field names do not change it. It is not used to lookup the field in external services, but only used internally in prompts sent to the AI model. */
    field_name: string;
    value_type?: "classification";
    options?: ClassificationOption[];
    is_multi?: boolean;
    allow_additional_options?: boolean;
    default_option?: ClassificationOption | null;
};
export type FieldExtractionConfig = {
    prompt_model_type?: "field_extraction";
    input_type?: "evisort_document";
    output_type: "string" | "text_area" | "int" | "float" | "datetime";
    scope?: SearchScope;
    internal: string;
    instructions?: string;
    /** A description of the field to be extracted or classified. */
    field_description?: string;
    /** The name of the field to be extracted or classified. This is frozen at the time the version is created and updates to field names do not change it. It is not used to lookup the field in external services, but only used internally in prompts sent to the AI model. */
    field_name: string;
    /** How exact matches need to be when evaluating correct output.
      | Level | Description |
      |-------|-------------|
      | `0` | The extracted value must be an exact match to the gold value |
      | `1` | The extracted value must match except for punctuation |
      | `2` | The extracted value must match 90% of the text |
      | `3` | The extracted value must match 90% of the words |
      | `4` | The extracted value must be the same as the gold value according to the LLM model |
      
      NOTE: only relevant when evaluating `string`/`text_area` fields.
       */
    string_matching_level?: StringMatchingLevel;
    /** Optional instructions for reformatting the extracted value.
      For non-text fields, this is not editable by the user and the defaults will be used
      However, for text fields the user can specify this behavior */
    reformatting_instructions?: string | null;
};
export type TableExtractionConfig = {
    prompt_model_type?: "table_extraction";
    input_type?: "evisort_document";
    output_type?: "table_value";
    scope?: SearchScope;
    internal: string;
    instructions?: string;
    /** The schema definition for the table to be extracted. */
    table_spec: TableSpec;
};
export type PromptModelConfig2 = ({
    prompt_model_type: "field_classification";
} & FieldClassificationConfig) | ({
    prompt_model_type: "field_extraction";
} & FieldExtractionConfig) | ({
    prompt_model_type: "table_extraction";
} & TableExtractionConfig);
export type InitialLibraryModelVersionCreate = {
    /** Name of the model. */
    name: string;
    /** Description of the model. */
    description: string;
    /** Sample outputs for the model, in markdown format. */
    sample_outputs: LibrarySampleOutputs;
    /** Tags for the model. */
    tags?: LibraryTag[];
    /** Changes since previous version */
    changelog_entry: string;
    /** Target information for the model. */
    target: ({
        entity_type: "document_attached_data";
    } & DocumentAttachedDataTargetInformation) | ({
        entity_type: "field";
    } & FieldTargetInformation);
    /** Configuration for the model. */
    configuration: PromptModelConfig2;
    /** Initial version number of the model. */
    initial_version?: string;
};
export type LibraryPublishState = "pending" | "done" | "error";
export type LibraryPublishStatus = {
    library_model_id: string;
    library_model_version_number: string;
    /** The linked prompt model ID (if ready) */
    prompt_model_id?: string | null;
    state: LibraryPublishState;
    /** Error message if state is ERROR */
    error_message?: string | null;
};
export type LibraryPublishResponse = {
    publishes: LibraryPublishStatus[];
};
export type LibraryPublishConfigOverrides = {
    /** If provided, the scope of the model to publish (otherwise uses the default scope for the model). */
    scope?: SearchScope | null;
};
export type LibraryPublishCreate = {
    library_model_id: string;
    library_model_version_number: string;
    /** If true, the new model will not be published - instead it will only be saved as a draft */
    draft?: boolean;
    /** If provided, overrides for the model configuration */
    config_overrides?: LibraryPublishConfigOverrides | null;
};
export type LibraryPublishRequest = {
    publishes: LibraryPublishCreate[];
};
export type GetLibraryModelResponse = {
    /** List of model versions. */
    versions: ApiLibraryModelVersion[];
};
export type NextLibraryModelVersionCreate = {
    /** Name of the model. */
    name: string;
    /** Description of the model. */
    description: string;
    /** Sample outputs for the model, in markdown format. */
    sample_outputs: LibrarySampleOutputs;
    /** Tags for the model. */
    tags?: LibraryTag[];
    /** Changes since previous version */
    changelog_entry: string;
    /** Target information for the model. */
    target: ({
        entity_type: "document_attached_data";
    } & DocumentAttachedDataTargetInformation) | ({
        entity_type: "field";
    } & FieldTargetInformation);
    /** Configuration for the model. */
    configuration: PromptModelConfig2;
    /** Type of update to perform. */
    update_type: "major" | "minor" | "patch";
};
export type DdeExtractionTable = {
    /** DDE extraction table UUID. */
    id: string;
    /** User-visible extraction table name (platform max name length). */
    name: string;
    client_id: string;
    user_id: string;
    /** Accessible handler rows in scope; from Evisearch results when scoped by document handler. */
    document_count?: number;
    datetime_created: string;
    datetime_updated: string;
};
export type DdeExtractionTableCreate = {
    /** User-visible extraction table name (platform max name length). */
    name: string;
};
export type DdeExtractionTableListItem = {
    /** DDE extraction table UUID. */
    id: string;
    /** User-visible extraction table name (platform max name length). */
    name: string;
    client_id: string;
    user_id: string;
    /** Accessible handler rows in scope; from Evisearch results when scoped by document handler. */
    document_count?: number;
    datetime_created: string;
    datetime_updated: string;
    /** Number of AI column models on the table. */
    dde_model_count?: number;
    /** Count of cells with status found across all AI columns at each column's latest version (same version-scoped semantics as Custom AI values_found). */
    total_extraction_count?: number;
};
export type PageDdeExtractionTableListItem = {
    items: DdeExtractionTableListItem[];
    total: number;
    page: number;
    size: number;
    pages: number;
};
export type DdeExtractionTableRename = {
    /** User-visible extraction table name (platform max name length). */
    name: string;
};
export type DdeModelListItem = {
    /** DDE model (AI column) UUID. */
    dde_model_id: string;
    /** User-visible extraction Model name (platform max name length). */
    name: string;
    /** Latest version number for this column, if any. */
    version_number?: number | null;
    /** Latest version configuration (PromptModelConfig); null if no version yet. */
    configuration?: PromptModelConfig | null;
};
export type DdeExtractionTableRow = {
    /** Document handler id. */
    id: string;
    /** Document display name. */
    name?: string;
    /** File extension (e.g. .pdf). */
    file_type?: string;
    /** Contract type. */
    contract_type?: string;
    /** Document upload date (ISO date when available). */
    upload_date?: string;
    /** Extraction values keyed by dde_model_id. */
    dde_model_values?: {
        [key: string]: any;
    };
};
export type DdeExtractionTableRowsPage = {
    /** DDE model columns for the table (id, name, version, configuration). */
    dde_models?: DdeModelListItem[];
    /** Handler metadata rows for the requested page (may exceed page_size on grouped documents). */
    rows?: DdeExtractionTableRow[];
    /** Evisearch document-hit page number (1-based). */
    page: number;
    /** Evisearch document hits per page, not handler rows. */
    page_size: number;
    /** Total ACL-filtered handler rows in table scope. */
    total_count?: number;
};
export type DdeModel = {
    /** DDE model (AI column) UUID. */
    id: string;
    /** User-visible extraction Model name (platform max name length). */
    model_name: string;
    /** DDE extraction table UUID. */
    table_id: string;
    user_id: string;
    /** Prompt model UUID when created from an existing model, null for custom columns. */
    prompt_model_id?: string | null;
    /** Custom AI published version number copied at column create; used for prediction workflow lookup. Null for custom columns. */
    prompt_model_version?: number | null;
    datetime_created: string;
    datetime_updated: string;
};
export type DdeModelVersion = {
    /** DDE model (AI column) UUID. */
    dde_model_id: string;
    version_number: number;
    configuration: PromptModelConfig;
    user_id: string;
    user_email: string;
    datetime_created: string;
};
export type DdeModelCreateResult = {
    model: DdeModel;
    version: DdeModelVersion;
};
export type DdeModelCreate = {
    /** User-visible extraction Model name (platform max name length). */
    model_name: string;
    /** Existing prompt model to clone when adding a column from AI field suggestions. */
    prompt_model_id?: string | null;
    /** Initial extraction configuration for custom columns; creates version 1 in the same request. */
    configuration?: PromptModelConfigCreate | null;
};
export type DdeModelVersionCreate = {
    configuration: PromptModelConfigCreate;
};
export type DdeExtractionStartResponse = {
    /** One extraction run per AI column started (bare UUIDs). */
    run_ids?: string[];
    /** Reserved for live SSE updates (not used until stream support ships). */
    stream_id?: string | null;
};
export type HealthcheckStatus = "healthy" | "unhealthy";
export type CheckResult = {
    name: string;
    status: HealthcheckStatus;
    details?: {
        [key: string]: any;
    };
};
export type HealthcheckResponse = {
    status: HealthcheckStatus;
    checks: CheckResult[];
};
